<script>
  export let routes_db, socket_query, units_travel_db;
  import { onMount, onDestroy, tick } from "svelte";
  import {
    units_list,
    nicks_list,
    geos,
    geos_class,
    travels,
    table_pos,
    live,
    drivers_list,
    drivers,
    geos_class_list,
    route_list,
    route_list_d,
    travel_crtl,
    geos_joined,
    geos_class_join,
    internal_com,
    map_ready,
    monitor_extra_map,
    recognition,
    unit_groups,
    geos_full,
  } from "./stores.js";
  import {
    EXT_OMNI_GEOC_URL,
    EXT_OMNI_ROUTE_URL,
  } from "./external-service-urls.js";

  let key,
    nicks_,
    nicks = {};
  let parametros = new URLSearchParams(window.location.search);
  key = parametros.get("key");
  nicks_ = parametros.get("nicks");

  if (key != null) {
    //embed_dtc_worker.postMessage({type:"save",key:"embedded_key",message:key});
    /*
        socket_query.emit('embedded_key',key,(data)=> {
            if(data=="error"){
                alert("Login incorrecto");
            }
        });
        */
  }

  const bc = new BroadcastChannel("map_external");
  const bc_route = new BroadcastChannel("map_external_route");
  const bc_coordenadas = new BroadcastChannel("map_external_coordenadas");

  function normalizeTravelIdAdd(value) {
    if (Array.isArray(value)) {
      return value.flatMap((entry) => normalizeTravelIdAdd(entry));
    }
    if (typeof value === "string") {
      return value
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry !== "");
    }
    if (value == null || value === false) {
      return [];
    }
    return [String(value)];
  }

  let mod_on = {};
  var observer = new IntersectionObserver(function (entry) {
    for (let x in entry) {
      if (entry[x].isIntersecting)
        mod_on[entry[x].target.id.split("_")[1]] = true;
      else delete mod_on[entry[x].target.id.split("_")[1]];
    }
    //monitor2();
  });
  function monitor_v(e) {
    observer.observe(e);
  }

  let map_cover = false;
  function CenterControl(controlDiv, map) {
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginBottom = "22px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click para ver mapa de cobertura";
    controlDiv.appendChild(controlUI);

    var controlText = document.createElement("div");
    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText.style.fontSize = "12px";
    controlText.style.lineHeight = "20px";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.style["min-width"] = "104px";
    controlText.innerHTML = map_cover ? "Hide 3G coverage" : "See 3G coverage";
    controlUI.appendChild(controlText);

    var controlUI2 = document.createElement("div");
    controlUI2.style.backgroundColor = "#fff";
    controlUI2.style.border = "2px solid #fff";
    controlUI2.style.borderRadius = "3px";
    controlUI2.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI2.style.cursor = "pointer";
    controlUI2.style.marginBottom = "22px";
    controlUI2.style.textAlign = "center";
    controlUI2.title = "Click para ver mapa de trafico";
    controlDiv.appendChild(controlUI2);

    var controlText2 = document.createElement("div");
    controlText2.style.color = "rgb(25,25,25)";
    controlText2.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText2.style.fontSize = "12px";
    controlText2.style.lineHeight = "20px";
    controlText2.style.paddingLeft = "5px";
    controlText2.style.paddingRight = "5px";
    controlText2.style["min-width"] = "104px";
    controlText2.innerHTML = map_traffic ? "Hide traffic" : "See traffic";
    controlUI2.appendChild(controlText2);

    controlUI.addEventListener("click", function () {
      map_cover = !map_cover;
      mapa_cobertura(map_cover);
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].pop();
      var centerControlDiv = document.createElement("div");
      var centerControl = new CenterControl(centerControlDiv, map);
      centerControlDiv.index = 1;
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
        centerControlDiv
      );
    });

    const trafficLayer = new google.maps.TrafficLayer();
    controlUI2.addEventListener("click", function () {
      map_traffic = !map_traffic;

      if (map_traffic) trafficLayer.setMap(map);
      else trafficLayer.setMap(null);
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].pop();
      var centerControlDiv = document.createElement("div");
      var centerControl = new CenterControl(centerControlDiv, map);
      centerControlDiv.index = 1;
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
        centerControlDiv
      );
    });
  }

  let map_traffic = false;

  let map;
  let on_map = false;
  let mount_complete = false;
  function initMap() {
    let bounds = new google.maps.LatLngBounds();
    bounds.extend({ lat: 32.534353, lng: -117.123783 });
    bounds.extend({ lat: 21.137926, lng: -86.740844 });
    bounds.extend({ lat: 14.534659, lng: -92.231633 });
    map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 24.458489, lng: -102.217231 },
      zoom: 5,
      styles: [
        {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape.man_made",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "landscape.natural",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
      ],
    });
    map.addListener("mouseover", function () {
      on_map = true;
    });
    map.addListener("mouseout", function () {
      on_map = false;
    });
    map.fitBounds(bounds);

    var centerControlDiv = document.createElement("div");
    var centerControl = new CenterControl(centerControlDiv, map);
    centerControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      centerControlDiv
    );

    geocoder = new google.maps.Geocoder();
  }

  function mapa_cobertura(type) {
    if (type) {
      var tech = "umts";
      var layers = [tech + "_garantizada"]; //tech + '_no_garantizada',
      for (let x in layers) {
        var layer = new google.maps.ImageMapType({
          getTileUrl: function getTileUrl(coord, zoom) {
            var url = "https://lbsva.telcel.com/tiles/gwc/service/wmts?";
            url += "layer=telcel:" + layers[x];
            url += "&style=";
            url += "&tilematrixset=EPSG:900913";
            url += "&Service=WMTS";
            url += "&Request=GetTile";
            url += "&Version=1.0.0";
            url += "&Format=image/png";
            url += "&TileMatrix=EPSG:900913:" + zoom;
            url += "&TileCol=" + coord.x;
            url += "&TileRow=" + coord.y;
            return url;
          },
          tileSize: new google.maps.Size(256, 256),
          isPng: true,
        });
        map.overlayMapTypes.push(layer);
      }
    } else {
      map.overlayMapTypes.clear();
    }
  }

  onMount(() => {
    mount_complete = true;
  });
  $: {
    if ($map_ready == 1 && mount_complete) {
      initMap();
      console.log("mapa cargado");
    }
  }

  let monitor_;
  let alert_reload_interval = null;
  onDestroy(() => {
    clearInterval(monitor_);
    if (alert_reload_interval) {
      clearInterval(alert_reload_interval);
    }
  });

  let units_fw = [
    { type: "geo", name: "Agencia Corona La Alborada", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona Tamaulipas" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona La Alborada" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
    { type: "geo", name: "Agencia Corona Tamaulipas" },
    { type: "unit", id: "4864071059" },
    { type: "unit", id: "4864071059" },
  ];

  let units_ufw = [
    { type: "unit", nick: "TZ-419", id: "4864071059" },
    { type: "unit", nick: "TZ-210", id: "4864071059" },
    { type: "unit", nick: "TZ-200", id: "4864071059" },
    { type: "unit", nick: "TZ-100", id: "4864071059" },
    { type: "unit", nick: "TZ-419", id: "4864071059" },
    { type: "unit", nick: "TZ-210", id: "4864071059" },
    { type: "unit", nick: "TZ-200", id: "4864071059" },
    { type: "unit", nick: "TZ-100", id: "4864071059" },
  ];

  //let travels_fw =[{id:"TZ-000",state:"NOK",ign:0,ruta:{name:"Ruta Corona La Alborada a Patio Tuxtepec", id:"4923043"},org:{name:"Agencia Corona La Alborada",id:"385434",time:"19/02/20 8:32"},dest:{name:"Desconocido",id:""},gps:{level:0.8},gsm:{level:0.8,last:400},mov:{speed:0,time_stop:305},monitor_crtl:{follow:1}}, {id:"TZ-001",state:"OK",ign:"ON",ruta:{name:"Ruta Corona La Alborada a Corona Tamaulipas", id:"4923043"},org:{name:"Agencia Corona La Alborada",id:"385434",time:"19/02/20 7:22"},dest:{name:"Agencia Corona Tamaulipas",id:"385434"},gps:{level:0.8},gsm:{level:0.8,last:38},mov:{speed:54,time_stop:0},monitor_crtl:{follow:1}}];

  let travels_ufw = [
    {
      nick: "TZ-111",
      state: "OK",
      ign: 1,
      ruta: {
        name: "Ruta Corona La Alborada a Corona Tamaulipas",
        id: "4923043",
      },
      org: {
        name: "Agencia Corona La Alborada",
        id: "385434",
        time: "19/02/20 7:22",
      },
      dest: { name: "Agencia Corona Tamaulipas", id: "385434" },
      gps: { state: "OK", level: 0.8 },
      gsm: { state: "OK", level: 0.8, last: 38 },
      mov: { speed: 54, time_stop: 0 },
    },
  ];

  function time_code_s_(time) {
    if (time < 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 60 * 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 60 * 60 * 24) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("H[h] m[min]");
    } else if (time < 60 * 60 * 24 * 90) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("D[d] H[h] m[min]");
    } else {
      return "+3 meses";
    }
  }

  function time_code_s(time) {
    //if(time<60){return moment.utc().subtract(1, 'years').startOf('years').add({ seconds: time }).format('s[s]')} // 's[s]'
    if (time < 60) {
      return "0m";
    } else if (time < 3600) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 86400) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("H[h] m[min]");
    } else if (time < 7776000) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("D[d] H[h] m[min]");
    } else {
      return "+3 meses";
    }
  }

  function time_code(time) {
    if (time < 60) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("m[min]");
    } else if (time < 60 * 24) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("H[h] m[min]");
    } else {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ minutes: time })
        .format("D[d] H[h] m[min]");
    }
  }

  units_ufw = [];
  travels_ufw = [];
  let travels_fw = [];
  let travels_fz = {};
  let travels_fh = [];
  units_fw = [];
  let units_fw_p = {};
  let geo_dic = {};
  let travels_fw_master = {};
  let paginas_l = [];
  monitor_ = setInterval(monitor2, 1000);
  $: {
    $nicks_list;
    let travel_keys = $units_list;
    let add_new = false;
    for (let x in travel_keys) {
      let t_found = false;
      let mobid = travel_keys[x];
      for (let y in travels_fh) {
        if (travels_fh[y]["id"] == mobid) {
          t_found = true;
        }
      }
      if (!t_found) {
        travels_fh.push({ id: mobid });
        travels_fz[mobid] = {
          mov: {},
          dest: {},
          ruta: {},
          gsm: { last: 0 },
          gps: {},
          pos: {},
          org: { time: "", name: "Desconocido" },
          geo_stay: [],
          alerts_list: [],
          state: "OK",
          monitor_crtl: { follow: 0 },
          oper: "Desconocido",
          alerts_now: 0,
        };
        add_new = true;
      }
    }
    if (add_new) {
      for (let w in travels_fh) {
        travels_fw_master[travels_fh[w].id] = w;
      }
    }
    travels_fh.sort(travels_order);
    let travels_fh_c = 0;
    let paginas_c = 0;
    paginas_l = [];
    for (let x in travels_fh) {
      if (travels_fh_c < 100) {
        travels_fh[x]["page"] = 0;
      } else if (travels_fh_c < 200) {
        travels_fh[x]["page"] = 1;
      } else if (travels_fh_c < 300) {
        travels_fh[x]["page"] = 2;
      } else if (travels_fh_c < 400) {
        travels_fh[x]["page"] = 3;
      } else if (travels_fh_c < 500) {
        travels_fh[x]["page"] = 4;
      } else if (travels_fh_c < 600) {
        travels_fh[x]["page"] = 5;
      } else if (travels_fh_c < 700) {
        travels_fh[x]["page"] = 6;
      } else if (travels_fh_c < 800) {
        travels_fh[x]["page"] = 7;
      } else if (travels_fh_c < 900) {
        travels_fh[x]["page"] = 8;
      } else if (travels_fh_c < 1000) {
        travels_fh[x]["page"] = 9;
      }
      travels_fh_c++;
    }
    paginas_c = Math.ceil(travels_fh_c / 100);
    if (paginas_c > 10) paginas_c = 10;
    for (let x = 0; x < paginas_c; x++) {
      paginas_l.push(x);
    }
  }

  function monitor2() {
    let live_ = $live;
    let travels_ = $travels;
    let travel_keys = Object.keys(travels_);
    let now_ = Math.round(new Date().getTime() / 1000);
    for (let x in travel_keys) {
      let mobid = travel_keys[x];
      let time_stop = 0;
      if (
        typeof travels_[mobid] != "undefined" &&
        typeof travels_fz[mobid] != "undefined"
      ) {
        if (true) {
          //(mod_on[mobid]||typeof travels_fz[mobid]["ok"]=="undefined")
          if (
            travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
              "last_status"
            ] == 1 ||
            travels_[mobid]["travel"].length > 1
          ) {
            if (
              travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                "last_status"
              ] == 1
            ) {
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                  "pos"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 1
                  ]["pos"].length - 1
                ];
              time_stop =
                time_stop.length > 4 ? time_stop[4] - time_stop[3] : 0;
            } else {
              let now = Math.round(new Date().getTime() / 1000);
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 2][
                  "pos"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 2
                  ]["pos"].length - 1
                ];
              time_stop =
                time_stop.length > 4
                  ? time_stop[4] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["date_start"]
                  : time_stop[3] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["date_start"];
              time_stop = Math.round((now - time_stop) / 60);
            }

            if (travels_fz[mobid].org.name == "Desconocido") {
              let lat_org_ =
                travels_[mobid]["travel"][0]["pos_start"][0] / 10000;
              let lng_org_ =
                travels_[mobid]["travel"][0]["pos_start"][1] / 10000;
              let geo_org_ = geo_search(lat_org_, lng_org_);
              travels_fz[mobid].org.name = geo_org_[0];
              let org_time_ = moment(
                new Date(travels_[mobid]["travel"][0]["date_start"] * 1000)
              ).format("DD/MM/YY HH:mm");
              travels_fz[mobid].org.time = org_time_;
            }
          }
          travels_fz[mobid]["alerts_now"] =
            typeof travels_[mobid]["alerts_now"] != "undefined"
              ? travels_[mobid]["alerts_now"]
              : travels_fz[mobid]["alerts_now"];
          travels_fz[mobid]["proto_status"] =
            typeof travels_[mobid]["proto_status"] != "undefined"
              ? travels_[mobid]["proto_status"]
              : "";
          travels_fz[mobid].mov.time_stop = time_stop;
          travels_fz[mobid]["monitor_crtl"] = travels_[mobid]["monitor_crtl"];
          travels_fz[mobid]["oper"] =
            typeof travels_[mobid]["monitor_crtl"]["driver"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["driver"] == ""
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["driver"];
          travels_fz[mobid]["dest"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["destino"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["destino"] == ""
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["destino"];
          travels_fz[mobid]["ruta"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["ruta"] == "undefined"
              ? "Desconocida"
              : travels_[mobid]["monitor_crtl"]["ruta"] == ""
              ? "Desconocida"
              : travels_[mobid]["monitor_crtl"]["ruta"];
          travels_fz[mobid]["alerts_list"] =
            typeof travels_[mobid]["alerts_list"] == "undefined"
              ? []
              : travels_[mobid]["alerts_list"];

          let live_mob = live_[mobid];
          if (
            typeof live_mob != "undefined" &&
            (typeof mod_on[mobid] != "undefined" ||
              typeof travels_fz[mobid]["ok"] == "undefined")
          ) {
            //()
            let time_last = now_ - live_mob["last_comm"];
            travels_fz[mobid].gsm.last = time_last < 300 ? true : false;
            travels_fz[mobid].gsm.text = time_code_s(time_last); //time_code_s
            travels_fz[mobid].mov.speed = live_mob["vel"];
            travels_fz[mobid].gsm.level = live_mob["rssi"];
            travels_fz[mobid].gps.level = live_mob["hdop"];
            travels_fz[mobid].gsm.net = live_mob["network"];
            travels_fz[mobid].ign = live_mob["ingnition"];

            if (
              travels_fz[mobid].pos.lat != live_mob["lat"] &&
              travels_fz[mobid].pos.lon != live_mob["lon"]
            ) {
              travels_fz[mobid].pos.lat = live_mob["lat"];
              travels_fz[mobid].pos.lon = live_mob["lon"];
              let geo_stay_ = geo_search(live_mob["lat"], live_mob["lon"]);
              travels_fz[mobid].geo_stay =
                geo_stay_[0] != "Geocerca_automatica_"
                  ? geo_stay_[1] == 1 && last_geocode == mobid
                    ? travels_fz[mobid].geo_stay
                    : geo_stay_
                  : last_geocode != mobid
                  ? ["", 1, ""]
                  : travels_fz[mobid].geo_stay;
            }
            travels_fz[mobid]["ok"] = "ok";
          }
        }
      }
    }
  }
  function monitor() {
    let live_ = $live;
    let travels_ = $travels;
    let travels_fw_len = travels_fw.length;
    let travel_keys = Object.keys(travels_);
    for (let x in travel_keys) {
      let mobid = travel_keys[x];
      let t_found = false;
      let t_found_p = -1;
      for (let y in travels_fw) {
        if (travels_fw[y]["id"] == mobid) {
          t_found = true;
          t_found_p = y;
          let time_stop = 0;
          if (
            travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
              "last_status"
            ] == 1 ||
            travels_[mobid]["travel"].length > 1
          ) {
            if (
              travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                "last_status"
              ] == 1
            ) {
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                  "pos"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 1
                  ]["pos"].length - 1
                ];
              time_stop =
                time_stop.length > 4 ? time_stop[4] - time_stop[3] : 0;
            } else {
              let now = Math.round(new Date().getTime() / 1000);
              time_stop =
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 2][
                  "pos"
                ][
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 2
                  ]["pos"].length - 1
                ];
              time_stop =
                time_stop.length > 4
                  ? time_stop[4] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["date_start"]
                  : time_stop[3] * 60 +
                    travels_[mobid]["travel"][
                      travels_[mobid]["travel"].length - 2
                    ]["date_start"];
              time_stop = Math.round((now - time_stop) / 60);
            }

            if (travels_fw[t_found_p].org.name == "Desconocido") {
              let lat_org_ =
                travels_[mobid]["travel"][0]["pos_start"][0] / 10000;
              let lng_org_ =
                travels_[mobid]["travel"][0]["pos_start"][1] / 10000;
              let geo_org_ = geo_search(lat_org_, lng_org_);
              travels_fw[t_found_p].org.name = geo_org_[0];
              let org_time_ = moment(
                new Date(travels_[mobid]["travel"][0]["date_start"] * 1000)
              ).format("DD/MM/YY HH:mm");
              travels_fw[t_found_p].org.time = org_time_;
            }
          }
          travels_fw[t_found_p]["alerts_now"] =
            typeof travels_[mobid]["alerts_now"] != "undefined"
              ? travels_[mobid]["alerts_now"]
              : travels_fw[t_found_p]["alerts_now"];
          travels_fw[t_found_p]["proto_status"] =
            typeof travels_[mobid]["proto_status"] != "undefined"
              ? travels_[mobid]["proto_status"]
              : "";
          travels_fw[t_found_p].mov.time_stop = time_stop;
          travels_fw[t_found_p]["monitor_crtl"] =
            travels_[mobid]["monitor_crtl"];
          travels_fw[t_found_p]["oper"] =
            typeof travels_[mobid]["monitor_crtl"]["driver"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["driver"] == ""
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["driver"];
          travels_fw[t_found_p]["dest"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["destino"] == "undefined"
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["destino"] == ""
              ? "Desconocido"
              : travels_[mobid]["monitor_crtl"]["destino"];
          travels_fw[t_found_p]["ruta"]["name"] =
            typeof travels_[mobid]["monitor_crtl"]["ruta"] == "undefined"
              ? "Desconocida"
              : travels_[mobid]["monitor_crtl"]["ruta"] == ""
              ? "Desconocida"
              : travels_[mobid]["monitor_crtl"]["ruta"];
          travels_fw[t_found_p]["alerts_list"] =
            typeof travels_[mobid]["alerts_list"] == "undefined"
              ? []
              : travels_[mobid]["alerts_list"];
          break;
        }
      }
      if (!t_found) {
        let time_stop = 0;
        let org_time = "";
        let ign = 0;
        let geo_org = ["Desconocido", 1, ""];
        let lat_org, lng_org;
        let oper =
          typeof travels_[mobid]["monitor_crtl"]["driver"] == "undefined"
            ? "Desconocido"
            : travels_[mobid]["monitor_crtl"]["driver"] == ""
            ? "Desconocido"
            : travels_[mobid]["monitor_crtl"]["driver"];
        let destino =
          typeof travels_[mobid]["monitor_crtl"]["destino"] == "undefined"
            ? "Desconocido"
            : travels_[mobid]["monitor_crtl"]["destino"] == ""
            ? "Desconocido"
            : travels_[mobid]["monitor_crtl"]["destino"];
        let ruta =
          typeof travels_[mobid]["monitor_crtl"]["ruta"] == "undefined"
            ? "Desconocida"
            : travels_[mobid]["monitor_crtl"]["ruta"] == ""
            ? "Desconocida"
            : travels_[mobid]["monitor_crtl"]["ruta"];
        let alerts_list =
          typeof travels_[mobid]["alerts_list"] == "undefined"
            ? []
            : travels_[mobid]["alerts_list"];

        let alerts_now =
          typeof travels_[mobid]["alerts_now"] != "undefined"
            ? travels_[mobid]["alerts_now"]
            : null;
        let proto_status =
          typeof travels_[mobid]["proto_status"] != "undefined"
            ? travels_[mobid]["proto_status"]
            : "";

        if (
          travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
            "last_status"
          ] == 1 ||
          travels_[mobid]["travel"].length > 1
        ) {
          if (
            travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
              "last_status"
            ] == 1
          ) {
            time_stop =
              travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                "pos"
              ][
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 1][
                  "pos"
                ].length - 1
              ];
            time_stop = time_stop.length > 4 ? time_stop[4] - time_stop[3] : 0;
          } else {
            let now = Math.round(new Date().getTime() / 1000);
            time_stop =
              travels_[mobid]["travel"][travels_[mobid]["travel"].length - 2][
                "pos"
              ][
                travels_[mobid]["travel"][travels_[mobid]["travel"].length - 2][
                  "pos"
                ].length - 1
              ];
            time_stop =
              time_stop.length > 4
                ? time_stop[4] * 60 +
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 2
                  ]["date_start"]
                : time_stop[3] * 60 +
                  travels_[mobid]["travel"][
                    travels_[mobid]["travel"].length - 2
                  ]["date_start"];
            time_stop = Math.round((now - time_stop) / 60);
          }

          org_time = moment(
            new Date(travels_[mobid]["travel"][0]["date_start"] * 1000)
          ).format("DD/MM/YY HH:mm");
          lat_org = travels_[mobid]["travel"][0]["pos_start"][0] / 10000;
          lng_org = travels_[mobid]["travel"][0]["pos_start"][1] / 10000;
          geo_org = geo_search(lat_org, lng_org);
          ign = 1;
        }

        travels_fw.push({
          id: mobid,
          state: "OK",
          ign: ign,
          ruta: { name: ruta, id: "" },
          org: {
            name: geo_org[0],
            id: geo_org[2],
            time: org_time,
          },
          dest: { name: destino, id: "" },
          alerts_list: alerts_list,
          gps: { level: 1 },
          gsm: { level: 1, last: true, net: "GSM", text: "+3 meses" },
          monitor_crtl: travels_[mobid]["monitor_crtl"],
          oper: oper,
          alerts_now: alerts_now,
          proto_status: proto_status,
          geo_stay: ["", 1, ""],
          mov: { speed: 0, time_stop: time_stop },
          pos: { lat: 0, lon: 0 },
        });
        t_found_p = travels_fw.length - 1;
      }
      let live_mob = live_[mobid];
      if (typeof live_mob != "undefined" && t_found_p != -1) {
        //travels_fw[t_found_p].gsm.last=live_mob["last_comm"];
        let time_last =
          Math.round(new Date().getTime() / 1000) - live_mob["last_comm"];
        travels_fw[t_found_p].gsm.last = time_last < 300 ? true : false;
        travels_fw[t_found_p].gsm.text = time_last; //time_code_s(time_last);
        travels_fw[t_found_p].mov.speed = live_mob["vel"];
        travels_fw[t_found_p].gsm.level = live_mob["rssi"];
        travels_fw[t_found_p].gps.level = live_mob["hdop"];
        travels_fw[t_found_p].gsm.net = live_mob["network"];
        travels_fw[t_found_p].ign = live_mob["ingnition"];

        if (
          travels_fw[t_found_p].pos.lat != live_mob["lat"] &&
          travels_fw[t_found_p].pos.lon != live_mob["lon"]
        ) {
          travels_fw[t_found_p].pos.lat = live_mob["lat"];
          travels_fw[t_found_p].pos.lon = live_mob["lon"];
          let geo_stay_ = geo_search(live_mob["lat"], live_mob["lon"]);
          travels_fw[t_found_p].geo_stay =
            geo_stay_[0] != "Geocerca_automatica_" ? geo_stay_ : ["", 1, ""];
        }
      }
    }
  }
  let total_alerts = 0;
  let total_follow = 0;
  let total_wating = 0;
  $: {
    let total_alerts_ = 0,
      total_follow_ = 0,
      total_wating_ = 0;
    for (let x in travels_fz) {
      if (travels_fz[x].alerts_now > 0) total_alerts_++;
      if (travels_fz[x].monitor_crtl.follow == 1) total_follow_++;
      if (
        travels_fz[x].proto_status != "" &&
        typeof travels_fz[x].proto_status != "undefined"
      ) {
        total_wating_++;
      }
    }
    total_alerts = total_alerts_;
    total_follow = total_follow_;
    total_wating = total_wating_;
  }

  function geo_search(lat, lng) {
    let found = false;
    for (let x in $geos) {
      for (let y in $geos[x][1]) {
        let lat_ = $geos[x][1][y][0];
        let lng_ = $geos[x][1][y][1];
        if (get_km(lat, lng, lat_, lng_) <= 0.13) {
          if (typeof $geos_class[$geos[x][0]] != "undefined") {
            return [
              $geos_class[$geos[x][0]][0],
              $geos_class[$geos[x][0]][1],
              $geos[x][0],
            ];
          } else {
            if (typeof $geos_joined[$geos[x][0]] == "undefined") {
              return [
                "Geocerca_automatica-" + $geos[x][0].split("-")[0],
                1,
                $geos[x][0],
              ];
            } else {
              for (let h in $geos_joined[$geos[x][0]]) {
                if (
                  typeof $geos_class[$geos_joined[$geos[x][0]][h]] !=
                  "undefined"
                ) {
                  return [
                    $geos_class[$geos_joined[$geos[x][0]][h]][0],
                    $geos_class[$geos_joined[$geos[x][0]][h]][1],
                    $geos_joined[$geos[x][0]][h],
                  ];
                }
              }
              return [
                "Geocerca_automatica-" + $geos[x][0].split("-")[0],
                1,
                $geos[x][0],
              ];
            }
          }
          found = true;
          break;
        }
      }
      if (found) {
        break;
      }
    }
    return ["Geocerca_automatica_", 1, ""];
  }
  function get_km(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * (Math.PI / 180);
    var dLon = (lon2 - lon1) * (Math.PI / 180);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }
  function travels_order(a, b) {
    if ($nicks_list[b.id] < $nicks_list[a.id]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
  let show_drivers = -1;
  let show_destinos = -1;
  let show_rutas = -1;
  let driver_selected;
  let destino_selected;
  let ruta_selected;
  function drivers_edit(i) {
    show_drivers = i;
  }
  function destino_edit(i) {
    show_destinos = i;
  }
  function ruta_edit(i) {
    show_rutas = i;
  }
  function save_driver(unit, driver_id) {
    console.log(unit, driver_id);
    socket_query.emit("driver_save", unit, driver_id, (data) => {
      if (data == "ok") {
        show_drivers = -1;
      }
    });
  }
  function save_destino(unit, destino_id) {
    console.log(unit, destino_id);
    socket_query.emit("destino_save", unit, destino_id, (data) => {
      if (data == "ok") {
        show_destinos = -1;
      }
    });
  }
  function save_ruta(unit, ruta_id) {
    console.log(unit, ruta_id);
    socket_query.emit("ruta_save", unit, ruta_id, (data) => {
      if (data == "ok") {
        show_rutas = -1;
      }
    });
  }
  let m_inicio, m_fin, recorrido, recorrido_ruta, m_inicio_ruta, m_fin_ruta;
  let l_ruta_estimada;
  let selected = -1;
  let selected_ = -1;
  let live_ = {};
  $: {
    const selectedLive = selected != -1 ? $live[selected] : null;
    if (selectedLive && selectedLive !== live_) {
      selected_ = selected;
      maping(selected, {});
      geo_loc();
    }
  }
  var circles = [];
  async function maping(mobid, source) {
    if (typeof source.target != "undefined") {
      if (source.target.id != "") {
        if (source.target.id == "alerts_box") {
          console.log("send alerts", source.target.attributes.mobid.value);
          socket_query.emit("alerts_now", source.target.attributes.mobid.value);
        }
        return 0;
      }
      //geocode($live[mobid].lat,$live[mobid].lon,mobid);
    }
    if (typeof $live[mobid] != "undefined")
      geocode($live[mobid].lat, $live[mobid].lon, mobid);
    if (typeof $travels[mobid] != "undefined") {
      if (
        $travels[mobid].monitor_crtl.follow == 0 &&
        (typeof $travels[mobid].monitor_crtl.ruta == "undefined" ||
          $travels[mobid].monitor_crtl.ruta == "")
      )
        ruta_estimada(mobid);
    }
    let bounds = new google.maps.LatLngBounds();
    let zIndex = 0;
    //console.log($travels[mobid],$live[mobid]);
    if (
      typeof $travels[mobid] == "undefined" ||
      typeof $live[mobid] == "undefined"
    ) {
      console.log("$travels||$live not ready");
      return 0;
    }
    if (typeof m_inicio != "undefined") {
      m_inicio.setMap(null);
    }
    if (typeof $travels[mobid].travel[0].pos != "undefined") {
      m_inicio = new google.maps.Marker({
        position: {
          lat: $travels[mobid].travel[0]["pos_start"][0] / 10000,
          lng: $travels[mobid].travel[0]["pos_start"][1] / 10000,
        },
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/dd-start.png",
        zIndex: zIndex,
      });
    }

    let icon_status =
      $live[mobid].ingnition == 0
        ? "wht-blank"
        : $live[mobid].vel == 0
        ? "purple-blank"
        : "grn-blank";
    var image = {
      url: "img/" + icon_status + ".png",
      scaledSize: new google.maps.Size(40, 40),
      labelOrigin: new google.maps.Point(20, -10),
    };

    zIndex++;
    if (typeof m_fin != "undefined") {
      m_fin.setMap(null);
    }
    if (typeof $live[mobid] != "undefined") {
      m_fin = new google.maps.Marker({
        position: { lat: $live[mobid].lat, lng: $live[mobid].lon },
        map: map,
        animation: google.maps.Animation.DROP,
        icon: image,
        zIndex: zIndex,
        label: {
          text:
            typeof $nicks_list[mobid] != "undefined"
              ? $nicks_list[mobid]
              : mobid,
          color: "#212121",
          fontSize: "13px",
          fontWeight: "bold",
        },
      });
    }

    let coordenada_ruta = [];
    /*
        if(typeof $travels[mobid].monitor_crtl.ruta!='undefined'&&false)
        {
            if($travels[mobid].monitor_crtl.ruta!="")
            {
                let route;
                try{route = await routes_db.getItem($travels[mobid].monitor_crtl.ruta);}catch(e){console.log("Error leyendo routa",e);}
                if(route!=null)
                {
                    let lat_org = route["pos_start"][0];
                    let lng_org = route["pos_start"][1];
                    for(let x in route["pos"])
                    {
                        let lat = (lat_org-route["pos"][x][0])/10000;
                        let lng = (lng_org-route["pos"][x][1])/10000;
                        coordenada_ruta.push({lat:lat,lng:lng});
                    }
                }
            }
        }
        
        zIndex++;
        if(typeof recorrido_ruta != 'undefined'){recorrido_ruta.setMap(null);}
        if(coordenada_ruta.length>0)
        {
            recorrido_ruta = new google.maps.Polyline({
                path: coordenada_ruta,
                geodesic: true,
                strokeColor: '#2196f3',
                strokeOpacity: 1.0,
                strokeWeight: 2.5,
                map: map,
                zIndex:zIndex
            });
        }

        zIndex++;
        if(typeof m_inicio_ruta != 'undefined'){m_inicio_ruta.setMap(null);}
        if(coordenada_ruta.length>0)
        {
            m_inicio_ruta = new google.maps.Marker({
                position: coordenada_ruta[0],
                map: map,
                animation: google.maps.Animation.DROP,
                icon: 'img/markerA.png',
                zIndex:zIndex
            });
        } 

        zIndex++;
        if(typeof m_fin_ruta != 'undefined'){m_fin_ruta.setMap(null);}
        if(coordenada_ruta.length>0)
        {
            m_fin_ruta = new google.maps.Marker({
                position: coordenada_ruta[coordenada_ruta.length-1],
                map: map,
                animation: google.maps.Animation.DROP,
                icon: 'img/markerB.png',
                zIndex:zIndex
            });
        }
        */
    zIndex++;
    zIndex++;
    zIndex++;
    post_mapping(mobid);

    let coordenada = [];
    for (let x in $travels[mobid].travel) {
      if (typeof $travels[mobid].travel[x].pos != "undefined") {
        for (let y in $travels[mobid].travel[x].pos) {
          let lat =
            ($travels[mobid].travel[x]["pos_start"][0] -
              $travels[mobid].travel[x]["pos"][y][0]) /
            10000;
          let lng =
            ($travels[mobid].travel[x]["pos_start"][1] -
              $travels[mobid].travel[x]["pos"][y][1]) /
            10000;
          coordenada.push({ lat: lat, lng: lng });
          bounds.extend({ lat: lat, lng: lng });
        }
      }
    }
    // OSRM
    /*
        let coordenada_osrm = "";
        let radius_osrm = "";
        for(let t in coordenada){coordenada_osrm=coordenada_osrm+coordenada[t].lng+","+coordenada[t].lat+";";}
        coordenada_osrm = coordenada_osrm + $live[mobid].lon+","+$live[mobid].lat+";";
        radius_osrm=radius_osrm+"20;";
        for(let t in coordenada){radius_osrm=radius_osrm+"20;";}

        coordenada_osrm = coordenada_osrm.slice(0, -1);
        radius_osrm = radius_osrm.slice(0, -1);
        let osrm_r = await fetch(EXT_OMNI_ROUTE_URL + "/match/v1/driving/"+coordenada_osrm+'?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full&radiuses='+radius_osrm);
        osrm_r = await osrm_r.json();
        if(osrm_r.code=="Ok")
        {
            if(osrm_r.matchings[0].confidence>0.6)
            {
                coordenada = [];
                for(let t in osrm_r.matchings)
                {
                    for(let y in osrm_r.matchings[t].geometry.coordinates)
                    {
                        coordenada.push({lat: osrm_r.matchings[t].geometry.coordinates[y][1], lng:osrm_r.matchings[t].geometry.coordinates[y][0]});
                    }
                }
            }
            console.log("confidence",osrm_r.matchings[0].confidence);
        }
        */
    //---------
    if (coordenada.length > 3) osrm(coordenada, zIndex, mobid);

    zIndex++;
    coordenada.push({ lat: $live[mobid].lat, lng: $live[mobid].lon });
    if (typeof recorrido != "undefined") {
      recorrido.setMap(null);
    }
    if (coordenada.length > 0) {
      recorrido = new google.maps.Polyline({
        path: coordenada,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2.5,
        map: map,
        zIndex: zIndex,
        icons: [
          {
            icon: {
              path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              strokeColor: "#b71c1c",
            },
            offset: "100px",
            repeat: "100px",
          },
        ],
      });
    }

    let geo_end = [];
    for (let x in circles) {
      circles[x].setMap(null);
    }
    if (typeof $travels[mobid].monitor_crtl.destino != "undefined") {
      if ($travels[mobid].monitor_crtl.destino != "") {
        if ($geos_full[$travels[mobid].monitor_crtl.destino] != null) {
          var geo = $geos_full[$travels[mobid].monitor_crtl.destino];
          let anti_f = 10;
          let last_join = "";
          while (typeof geo.join != "undefined" || anti_f == 0) {
            last_join = geo.join;
            geo = $geos_full[geo.join];
            anti_f--;
          }
          for (let y in geo["pos"]) {
            let lat = geo["pos"][y][0];
            let lng = geo["pos"][y][1];
            circles.push(
              new google.maps.Circle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                map: map,
                center: { lat: lat, lng: lng },
                radius: 100,
                zIndex: 3,
              })
            );
          }
          if (
            $travels[mobid].monitor_crtl.follow == 1 &&
            (typeof $travels[mobid].monitor_crtl.ruta == "undefined" ||
              $travels[mobid].monitor_crtl.ruta == "")
          ) {
            osrm_destino(geo["pos"][0][0], geo["pos"][0][1], zIndex, mobid);
            if (typeof m_fin_ruta != "undefined") {
              m_fin_ruta.setMap(null);
            }
            m_fin_ruta = new google.maps.Marker({
              position: { lat: geo["pos"][0][0], lng: geo["pos"][0][1] },
              map: map,
              animation: google.maps.Animation.DROP,
              icon: "img/markerB.png",
              zIndex: 0,
            });
          }
        }
      }
    }

    if (!on_map && typeof map != "undefined") {
      map.setZoom(14);
      map.panTo({ lat: $live[mobid].lat, lng: $live[mobid].lon });
    }

    if (selected == mobid && selected_ != mobid) {
      if (coordenada.length > 1 && show_drivers != mobid) {
        map.fitBounds(bounds);
      }
      selected_ = mobid;
    } else if (selected == mobid && selected_ == mobid) {
      selected_ = -1;
    }

    selected = mobid;
    live_ = $live[mobid];

    bc.postMessage({
      selected_: selected_,
      panTo: { lat: $live[mobid].lat, lng: $live[mobid].lon },
      recorrido: coordenada,
      m_fin_ruta:
        coordenada_ruta.length > 0
          ? coordenada_ruta[coordenada_ruta.length - 1]
          : "",
      m_inicio_ruta: coordenada_ruta.length > 0 ? coordenada_ruta[0] : "",
      recorrido_ruta: coordenada_ruta,
      m_inicio:
        typeof $travels[mobid].travel[0].pos != "undefined"
          ? {
              lat: $travels[mobid].travel[0]["pos_start"][0] / 10000,
              lng: $travels[mobid].travel[0]["pos_start"][1] / 10000,
            }
          : "",
      m_fin: { lat: $live[mobid].lat, lng: $live[mobid].lon },
      image_end: image,
      eco:
        typeof $nicks_list[mobid] != "undefined" ? $nicks_list[mobid] : mobid,
      target: typeof source.target,
    });
  }
  async function post_mapping(mobid) {
    let zIndex = 1;
    let coordenada_ruta = [];
    if (typeof $travels[mobid].monitor_crtl.ruta != "undefined") {
      if ($travels[mobid].monitor_crtl.ruta != "") {
        let route;
        try {
          route = await routes_db.getItem($travels[mobid].monitor_crtl.ruta);
        } catch (e) {
          console.log("Error leyendo routa", e);
        }
        if (route != null) {
          let lat_org = route["pos_start"][0];
          let lng_org = route["pos_start"][1];
          for (let x in route["pos"]) {
            let lat = (lat_org - route["pos"][x][0]) / 10000;
            let lng = (lng_org - route["pos"][x][1]) / 10000;
            coordenada_ruta.push({ lat: lat, lng: lng });
          }
        }
      }
    }

    zIndex++;
    if (typeof recorrido_ruta != "undefined") {
      recorrido_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      recorrido_ruta = new google.maps.Polyline({
        path: coordenada_ruta,
        geodesic: true,
        strokeColor: "#2196f3",
        strokeOpacity: 1.0,
        strokeWeight: 2.5,
        map: map,
        zIndex: zIndex,
      });
    }

    zIndex++;
    if (typeof m_inicio_ruta != "undefined") {
      m_inicio_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      m_inicio_ruta = new google.maps.Marker({
        position: coordenada_ruta[0],
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/markerA.png",
        zIndex: zIndex,
      });
    }

    zIndex++;
    if (typeof m_fin_ruta != "undefined") {
      m_fin_ruta.setMap(null);
    }
    if (coordenada_ruta.length > 0) {
      m_fin_ruta = new google.maps.Marker({
        position: coordenada_ruta[coordenada_ruta.length - 1],
        map: map,
        animation: google.maps.Animation.DROP,
        icon: "img/markerB.png",
        zIndex: zIndex,
      });
    }
    bc_route.postMessage({
      m_fin_ruta:
        coordenada_ruta.length > 0
          ? coordenada_ruta[coordenada_ruta.length - 1]
          : "",
      m_inicio_ruta: coordenada_ruta.length > 0 ? coordenada_ruta[0] : "",
      recorrido_ruta: coordenada_ruta,
    });
  }
  $: {
    selected;
    alert_reload();
    geo_loc();
  }
  function alert_reload() {
    if (selected != -1) {
      socket_query.emit("alert_reload", selected, 3, (data) => {});
    }
  }
  alert_reload_interval = setInterval(alert_reload, 60 * 1000);

  let geo_lc;
  function geo_loc() {
    if (
      selected != -1 &&
      $live[selected].lac != null &&
      $live[selected].cellid != 0
    ) {
      socket_query.emit(
        "geo_loc",
        $live[selected].lac,
        $live[selected].cellid,
        (data) => {
          //console.log("geo_loc",data);
          if (typeof geo_lc != "undefined") {
            geo_lc.setMap(null);
          }
          var antenna_ico = {
            url: "img/antenna.png",
            scaledSize: { width: 32, height: 32 },
          };
          geo_lc = new google.maps.Marker({
            position: { lat: data.lat / 10000, lng: data.lon / 10000 },
            map: map,
            animation: google.maps.Animation.DROP,
            icon: antenna_ico,
            zIndex: 0,
          });
        }
      );
    }
  }

  function ecm_reload() {
    if (selected != -1) {
      socket_query.emit("ecm_reload", selected, 3, (data) => {});
    }
  }

  let f_monitor = 1,
    f_alertas = 1,
    f_todas = 0,
    f_viaje = 1,
    f_sinviaje = 1,
    f_dispositivos = 1,
    f_unidades = 0,
    f_pag = 0;
  function filtro(i) {
    if (i == 0) {
      f_monitor = f_monitor == 1 ? 0 : 1;
    }
    if (i == 1) {
      f_alertas = f_alertas == 1 ? 0 : 1;
    }
    if (i == 2) {
      f_todas = f_todas == 1 ? 0 : 1;
    }
    if (i == 3) {
      f_viaje = f_viaje == 1 ? 0 : 1;
      f_sinviaje = f_viaje == 0 && f_sinviaje == 0 ? 1 : f_sinviaje;
    }
    if (i == 4) {
      f_sinviaje = f_sinviaje == 1 ? 0 : 1;
      f_viaje = f_sinviaje == 0 && f_viaje == 0 ? 1 : f_viaje;
    }
    if (i == 5) {
      f_dispositivos = 1;
      f_unidades = 0;
    }
    if (i == 6) {
      f_dispositivos = 0;
      f_unidades = 1;
    }

    if (i == 7) {
      f_pag = 0;
    }
    if (i == 8) {
      f_pag = 1;
    }
    if (i == 9) {
      f_pag = 2;
    }
    if (i == 10) {
      f_pag = 3;
    }
    if (i == 11) {
      f_pag = 4;
    }
    if (i == 12) {
      f_pag = 5;
    }
    if (i == 13) {
      f_pag = 6;
    }
    if (i == 14) {
      f_pag = 7;
    }
    if (i == 15) {
      f_pag = 8;
    }
    if (i == 16) {
      f_pag = 9;
    }
  }
  let future_travel = []; //[{id:"TZ-001",date_ini:"02/06/2020 10:37",org:{name:"Patio Zemog Tuxtepec"},dest:{name:"Agencia Modelo Juarez"},route:{name:"Patio Zemog Tuxtepec a Agencia Modelo Juarez"},oper:"Pedro Sanchez"},{id:"TZ-002",date_ini:"02/06/2020 10:37",org:{name:"Patio Zemog Tuxtepec"},dest:{name:"Agencia Modelo Juarez"},route:{name:"Patio Zemog Tuxtepec a Agencia Modelo Juarez"},oper:"Pedro Sanchez"}];
  let future_travel_r = [{ route_m: [] }];
  let eco_selected = "",
    org_selected = "",
    dest_selected = "",
    oper_selected = "",
    route_f_selected = "",
    fechas = [],
    fecha_v,
    hora_v;
  let eco_add_selected = [];
  let horas = [];
  let new_travel_s = false;
  function new_travel() {
    if (!new_travel_s) {
      eco_add_selected = [];
      let lista_viajes_prog = document.getElementById("lista_viajes_prog");
      lista_viajes_prog.scrollTop = 0;
      new_travel_s = true;
      fechas = [];
      horas = [];
      for (let x = 0; x < 3; x++) {
        fechas.push([
          moment().startOf("day").add(x, "days").valueOf() / 1000,
          moment().startOf("day").add(x, "days").format("DD-MM-YY"),
        ]);
      }
      for (let x = 0; x < 48; x++) {
        horas.push([
          x * 30 * 60,
          moment()
            .startOf("day")
            .add(x * 30, "minutes")
            .format("HH:mm"),
        ]);
      }
      future_travel.unshift({
        id: "",
        date_ini: "",
        org: { name: "" },
        dest: { name: "" },
        dest_m: [],
        route: { name: "" },
        route_m: [],
        oper: "",
        sec_dests: [],
        sec_routes: [],
      });
      future_travel_r = [{ route_m: [] }];
      //future_travel = [...future_travel];
    } else {
      new_travel_s = false;
      future_travel.splice(0, 1);
      //future_travel = [...future_travel];
      eco_selected = "";
      org_selected = "";
      dest_selected = "";
      oper_selected = "";
      route_f_selected = "";
      fecha_v = "";
      hora_v = "";
      eco_add_selected = [];
    }
  }
  let saved_ok = false;
  let saved_type, saved_text;
  function save_travel(id, date_ini) {
    if (new_travel_s) {
      // Guardar Viaje
      let future_travel_ex = true;

      let sec_dests = [];
      let sec_routes = [];
      for (let z in future_travel_r[0].route_m) {
        sec_routes.push(future_travel_r[0].route_m[z].name);
      }
      for (let z in future_travel[0].dest_m) {
        if (future_travel[0].dest_m[z].name == "") {
          future_travel_ex = false;
        }
        sec_dests.push(future_travel[0].dest_m[z].name);
      }

      if (
        eco_selected != "" &&
        org_selected != "" &&
        dest_selected != "" &&
        oper_selected != "" &&
        fecha_v != "" &&
        hora_v !== "" &&
        future_travel_ex &&
        eco_add_selected[eco_add_selected.length - 1] != ""
      ) {
        for (let f in $unit_groups) {
          if ($unit_groups[f][0] == eco_selected) {
            console.log("found group");
            for (let p in $unit_groups[f][1]) {
              let eco_add_selected_found = false;
              for (let g in eco_add_selected) {
                if (eco_add_selected[g] == $unit_groups[f][1][p]) {
                  eco_add_selected_found = true;
                }
              }
              if (!eco_add_selected_found) {
                eco_add_selected.push($unit_groups[f][1][p]);
              }
            }
          }
        }

        let fecha_total = fecha_v + hora_v;
        socket_query.emit(
          "travel_save",
          eco_selected,
          org_selected,
          dest_selected,
          oper_selected,
          route_f_selected,
          fecha_total,
          sec_dests,
          sec_routes,
          eco_add_selected,
          (data) => {
            if (data == "ok") {
              new_travel();
              saved_ok = true;
              saved_text = "Viaje guardado";
              saved_type = "alert-success";
              setTimeout(function () {
                saved_ok = false;
              }, 3000);
            } else {
              saved_ok = true;
              saved_text = "Error en cargar viaje";
              saved_type = "alert-danger";
              setTimeout(function () {
                saved_ok = false;
              }, 3000);
            }
          }
        );
      } else {
        saved_ok = true;
        saved_text = "Completa todos los datos";
        saved_type = "alert-danger";
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    } // Borrar Viaje
    else {
      e_selected = -1;
      socket_query.emit("travel_delete", id, date_ini, (data) => {
        if (data == "ok") {
          saved_ok = true;
          saved_text = "Viaje borrado";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      });
    }
  }
  let edit_mode = -1;
  let travel_toe = {};
  let travel_toe_ = {};
  let future_travel_backup = {};
  function edit_travel(i, w) {
    if (edit_mode == -1) {
      edit_mode = i;
      travel_toe.sec_dests = [...future_travel[w].sec_dests];
      travel_toe_.sec_dests = [...future_travel[w].sec_dests];
      travel_toe.sec_routes = [...future_travel[w].sec_routes];
      travel_toe_.sec_routes = [...future_travel[w].sec_routes];
      future_travel_backup.sec_dests = [...future_travel[w].sec_dests];
      future_travel_backup.sec_routes = [...future_travel[w].sec_routes];
      org_selected = future_travel[w].org;
      dest_selected = future_travel[w].dest;
      route_f_selected = future_travel[w].route;
      extra_selected(i);
    } else {
      edit_mode = -1;
      future_travel[w].sec_dests = [...future_travel_backup.sec_dests];
      future_travel[w].sec_routes = [...future_travel_backup.sec_routes];
      org_selected = "";
      dest_selected = "";
      route_f_selected = "";
    }
  }
  function save_edit_travel(id, date_ini) {
    console.log(travel_toe, org_selected, dest_selected, route_f_selected);
    let dest_c = travel_toe.sec_dests.length;
    for (let x in travel_toe.sec_dests) {
      if (travel_toe.sec_dests[x] != "") {
        dest_c--;
      }
    }
    if (org_selected != "" && dest_selected != "" && dest_c == 0) {
      socket_query.emit(
        "travel_update",
        id,
        date_ini,
        org_selected,
        dest_selected,
        route_f_selected,
        travel_toe.sec_dests,
        travel_toe.sec_routes,
        (data) => {
          if (data == "ok") {
            org_selected = "";
            dest_selected = "";
            route_f_selected = "";
            edit_mode = -1;
            saved_ok = true;
            saved_text = "Viaje actualizado";
            saved_type = "alert-success";
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          } else {
            saved_ok = true;
            saved_text = "Error en actualizar viaje";
            saved_type = "alert-danger";
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        }
      );
    } else {
      saved_ok = true;
      saved_text = "Completa todos los datos";
      saved_type = "alert-danger";
      setTimeout(function () {
        saved_ok = false;
      }, 3000);
    }
  }
  function add_destino(id, date_ini) {
    future_travel[0].dest_m.push({ name: "" });
    future_travel[0].route_m.push({ name: "" });
    future_travel_r[0].route_m.push({ name: "" });
    future_travel = [...future_travel];
    //console.log(future_travel[0]);
  }
  function launch_travel(id, date_ini, des, oper, route, id_add) {
    socket_query.emit(
      "travel_launch",
      id,
      date_ini,
      des,
      oper,
      route,
      id_add,
      (data) => {
        if (data == "ok") {
          saved_ok = true;
          saved_text = "Viaje iniciado";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        } else if (data == "error1") {
          saved_ok = true;
          saved_text = "Error, Unidad con viaje en proceso";
          saved_type = "alert-danger";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
  let units_list_p;
  $: {
    units_list_p = [...$units_list];
    $nicks_list;
    units_list_p.sort(units_order);
  }
  function units_order(a, b) {
    if ($nicks_list[b] < $nicks_list[a]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
  let future_travel_p = [];
  $: {
    future_travel_p = [...$travel_crtl];
    if (new_travel_s) {
      future_travel_p.unshift(future_travel[0]);
    }
    for (let x in future_travel_p) {
      future_travel_p[x].id_add = normalizeTravelIdAdd(future_travel_p[x].id_add);
    }
    future_travel = [...future_travel_p];
  }
  let route_list_ = [];
  $: {
    let route_list_p = [];
    $geos_class;
    $geos;
    for (let x in $route_list) {
      route_list_p.push($route_list[x]);
      let geo = geo_search(
        $route_list[x][2][0] / 10000,
        $route_list[x][2][1] / 10000
      );
      route_list_p[x][2][2] = geo[2];
      geo = geo_search(
        $route_list[x][3][0] / 10000,
        $route_list[x][3][1] / 10000
      );
      route_list_p[x][3][2] = geo[2];
    }
    route_list_ = [...route_list_p];
    //if(route_f_selected.length==1)
    //{
    //   ruta_selected =  route_list_[0][0];
    //   console.log(ruta_selected)
    //}
  }
  let e_selected = -1;
  function extra_selected(i) {
    e_selected = i;
  }
  function end_travel(id, date_ini, id_add) {
    socket_query.emit("end_travel", id, date_ini, id_add, (data) => {
      if (data == "ok") {
        saved_ok = true;
        saved_text = "Viaje Cerrado";
        saved_type = "alert-success";
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
        close_travel_modal = true;
      } else if (data == "error1") {
        saved_ok = true;
        saved_text =
          "Error, el viaje fue cerrado manualmente, asigne de nuevo al operador para cerrar correctamente.";
        saved_type = "alert-danger";
        setTimeout(function () {
          saved_ok = false;
        }, 5000);
      }
    });
  }
  let route_modal = false;
  let route_name;
  let route_modal_org = 0;
  let route_modal_edit = false;
  function route_options(i, edit) {
    console.log("route_modal_org", route_modal_org);
    route_modal_org = i;
    route_modal_edit = edit;
    let con_s = false;

    if (route_modal_org == 0) {
      if (org_selected != "" && dest_selected != "") con_s = true;
    } else if (route_modal_org == 1) {
      if (edit) {
        if (
          dest_selected != "" &&
          travel_toe.sec_dests[route_modal_org - 1] != ""
        )
          con_s = true;
        console.log(travel_toe.sec_dests[route_modal_org - 1]);
      } else {
        if (
          dest_selected != "" &&
          future_travel[0].dest_m[route_modal_org - 1].name != ""
        )
          con_s = true;
      }
    } else {
      if (edit) {
        if (
          travel_toe.sec_dests[route_modal_org - 2] != "" &&
          travel_toe.sec_dests[route_modal_org - 1] != ""
        )
          con_s = true;
      } else {
        if (
          future_travel[0].dest_m[route_modal_org - 2].name != "" &&
          future_travel[0].dest_m[route_modal_org - 1].name != ""
        )
          con_s = true;
      }
    }

    if (con_s) {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Generar nueva ruta",
            onClick: () => {
              route_modal = true;
            },
          },
          { label: "Cancelar", onClick: () => {} },
        ],
      });
    }
  }
  let map_routes;
  let all_steps;
  var directionsService;
  var directionsRenderer;
  let geocoder;
  function show_route_map() {
    let org_pos = "",
      dest_pos = "";
    let org_selected_, dest_selected_;
    for (let x in $geos_class_list) {
      if (route_modal_org == 0) {
        if ($geos_class_list[x][0] == org_selected) {
          org_selected_ = $geos_class_list[x][3];
        }
        if ($geos_class_list[x][0] == dest_selected) {
          dest_selected_ = $geos_class_list[x][3];
        }
      } else if (route_modal_org == 1) {
        if ($geos_class_list[x][0] == dest_selected) {
          org_selected_ = $geos_class_list[x][3];
        }
        if (route_modal_edit) {
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 1]
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        } else {
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 1].name
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        }
      } else {
        if (route_modal_edit) {
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 2]
          ) {
            org_selected_ = $geos_class_list[x][3];
          }
          if (
            $geos_class_list[x][0] == travel_toe.sec_dests[route_modal_org - 1]
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        } else {
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 2].name
          ) {
            org_selected_ = $geos_class_list[x][3];
          }
          if (
            $geos_class_list[x][0] ==
            future_travel[0].dest_m[route_modal_org - 1].name
          ) {
            dest_selected_ = $geos_class_list[x][3];
          }
        }
      }
    }
    for (let x in $geos) {
      if ($geos[x][0] == org_selected_) {
        org_pos = { lat: $geos[x][1][0][0], lng: $geos[x][1][0][1] };
      }
      if ($geos[x][0] == dest_selected_) {
        dest_pos = { lat: $geos[x][1][0][0], lng: $geos[x][1][0][1] };
      }
      if (org_pos != "" && dest_pos != "") {
        break;
      }
    }

    let bounds = new google.maps.LatLngBounds();
    bounds.extend({ lat: 32.534353, lng: -117.123783 });
    bounds.extend({ lat: 21.137926, lng: -86.740844 });
    bounds.extend({ lat: 14.534659, lng: -92.231633 });
    function initMap() {
      map_routes = new google.maps.Map(document.getElementById("map_routes"), {
        center: { lat: 24.458489, lng: -102.217231 },
        zoom: 5,
      });

      directionsService = new google.maps.DirectionsService();
      directionsRenderer = new google.maps.DirectionsRenderer({
        draggable: true,
        map: map_routes,
      });

      directionsRenderer.addListener("directions_changed", function () {
        directionsRenderer.setMap(map_routes);
        console.log(
          directionsRenderer.getDirections().routes[0].legs[0].distance.text
        );
        console.log(
          directionsRenderer.getDirections().routes[0].legs[0].duration.text
        );
        let steps = directionsRenderer.getDirections().routes[0].legs[0].steps;
        all_steps = [];
        for (let z in steps) {
          for (let w in steps[z].lat_lngs) {
            all_steps.push([
              steps[z].lat_lngs[w].lat(),
              steps[z].lat_lngs[w].lng(),
            ]);
          }
        }
        //console.log(all_steps);
      });

      if (org_pos != "" && dest_pos != "") {
        displayRoute(org_pos, dest_pos, directionsService, directionsRenderer);
      }
    }
    initMap();
    //map_routes.fitBounds(bounds);
  }
  function displayRoute(origin, destination, service, display) {
    console.log("displayRoute", "origin", origin, "destination", destination);
    service.route(
      {
        origin: origin,
        destination: destination,
        waypoints: [],
        travelMode: "DRIVING",
        avoidTolls: false,
      },
      function (response, status) {
        if (status === "OK") {
          //console.log("Servicio ok ",response);
          display.setDirections(response);
        } else {
          saved_ok = true;
          saved_text = "Ruta no disponible";
          saved_type = "alert-danger";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
  function save_new_route() {
    route_modal = false;
    let out_vector = [];
    if (all_steps.length > 0) {
      let lat_start = Math.round(all_steps[0][0] * 10000);
      let lng_start = Math.round(all_steps[0][1] * 10000);
      out_vector.push({
        pos_start: [lat_start, lng_start],
        pos: [[0, 0]],
        stops: [],
      });
      for (let x in all_steps) {
        let lat_ = Math.round(all_steps[x][0] * 10000);
        let lng_ = Math.round(all_steps[x][1] * 10000);
        if (
          lat_start != lat_ &&
          lng_start != lng_ &&
          (out_vector[0].pos[out_vector[0].pos.length - 1][0] !=
            lat_start - lat_ ||
            out_vector[0].pos[out_vector[0].pos.length - 1][1] !=
              lng_start - lng_)
        ) {
          out_vector[0].pos.push([lat_start - lat_, lng_start - lng_]);
        }
      }
      console.log(out_vector[0]);

      socket_query.emit(
        "route_save",
        route_name.value,
        out_vector[0],
        1,
        (data) => {
          if (data == "ok") {
            saved_type = "alert-success";
            saved_text = "Ruta Guardada";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        }
      );
    }
  }
  function cancel_new_route() {
    route_modal = false;
  }
  $: {
    if ($internal_com != null) {
      if (typeof $internal_com["monitor_set"] != "undefined")
        auto_select($internal_com["monitor_set"]);
    }
  }
  function auto_select(id) {
    if (selected != id) {
      maping(id, {});
      select_prog(id);
    }
    let unit_seg = document.getElementById("seg_" + id);
    if (unit_seg != null) {
      unit_seg.scrollIntoView();
    }
  }
  let total_terminado = 0;
  let total_en_proceso = 0;
  let future_travel_master = {};
  $: {
    let total_terminado_ = 0,
      total_en_proceso_ = 0;
    let future_travel_master_ = {};
    for (let x in future_travel) {
      if (future_travel[x].step - 2 == future_travel[x].sec_dests.length) {
        total_terminado_++;
      } else if (future_travel[x].step > 0) {
        total_en_proceso_++;
      }
      if (future_travel[x].step > 0) {
        future_travel_master_[future_travel[x].id] = normalizeTravelIdAdd(
          future_travel[x].id_add
        );
      }
    }
    total_terminado = total_terminado_;
    total_en_proceso = total_en_proceso_;
    future_travel_master = future_travel_master_;
  }
  let mapa_ex_mode = false;
  let external_map;
  function mapa_ex() {
    mapa_ex_mode = mapa_ex_mode ? false : true;
    if (mapa_ex_mode) {
      external_map = window.open("/mapa.html", "_blank");
      window.focus();
      monitor_extra_map.set(1);
    } else {
      monitor_extra_map.set(0);
      try {
        external_map.close();
      } catch (e) {}
    }
  }
  $: {
    mapa_ex_mode = $monitor_extra_map;
  }

  let observer_ops = {
    root: document.getElementById("followed_travel_list"),
    rootMargin: "0px",
    threshold: 0,
  };
  /*
    let observer_ctl = {};
    var observer = new IntersectionObserver(observer_func, observer_ops);
    async function observer_func(event)
    {
        for(let x in event)
        {
            observer_ctl[event[x].target.id.split("seg_")[1]]=event[x].isIntersecting;
            //console.log(observer_ctl);
        }
    }
    */
  function obs_travel(i) {
    //console.log(i.getAttribute("id"));
    //observer.observe(i);
  }

  let prog_selected = -1;
  function select_prog(id) {
    let found = false;
    for (let x in future_travel) {
      if (future_travel[x].step > 0 && future_travel[x].id == id) {
        prog_selected = id;
        found = true;
        let unit_prog = document.getElementById(
          "prog_" + id + future_travel[x].date_ini
        );
        if (unit_prog != null) {
          unit_prog.scrollIntoView();
        }
      }
    }
    if (!found) prog_selected = -1;
  }
  let close_travel_modal = false;
  function send_travel_modal() {
    socket_query.emit(
      "travel_comment",
      c_travel_uuid,
      travel_end_comment,
      parseInt(travel_end_reason),
      (data) => {
        if (data == "ok") {
          close_travel_modal = false;
          c_travel_uuid = "";
          travel_end_comment = "";
        }
      }
    );
  }
  let c_travel_uuid = "";
  let travel_end_reason = 0;
  let travel_end_comment = "";
  let travel_modal_id, travel_modal_date_ini, travel_modal_id_add;
  function end_travel_modal(id, date_ini, uuid, id_add) {
    c_travel_uuid = uuid;
    travel_end_reason = 0;
    con_close_travel_modal = true;
    travel_modal_id = id;
    travel_modal_date_ini = date_ini;
    travel_modal_id_add = id_add; //end_travel(id,date_ini,id_add);
  }

  function edit_del_destino(org, i) {
    if (i == 0 && future_travel[org].sec_dests.length > 0) {
      future_travel[org].dest = future_travel[org].sec_dests[0];
      future_travel[org].sec_dests.splice(0, 1);
      dest_selected = future_travel[org].dest;
      travel_toe.sec_dests.splice(0, 1);
      travel_toe_.sec_dests.splice(0, 1);

      future_travel[org].route = future_travel[org].sec_routes[0];
      future_travel[org].sec_routes.splice(0, 1);
      route_f_selected = future_travel[org].route;
      travel_toe.sec_routes.splice(0, 1);
      travel_toe_.sec_routes.splice(0, 1);
    } else {
      future_travel[org].sec_dests.splice(i - 1, 1);
      travel_toe.sec_dests.splice(i - 1, 1);
      travel_toe_.sec_dests.splice(i - 1, 1);

      future_travel[org].sec_routes.splice(i - 1, 1);
      travel_toe.sec_routes.splice(i - 1, 1);
      travel_toe_.sec_routes.splice(i - 1, 1);
    }
    future_travel[org] = future_travel[org];
  }
  function edit_add_destino(org, i) {
    future_travel[org].sec_dests.push("");
    travel_toe.sec_dests.push("");
    travel_toe_.sec_dests.push("");

    future_travel[org].sec_routes.push("");
    travel_toe.sec_routes.push("");
    travel_toe_.sec_routes.push("");

    future_travel[org] = future_travel[org];
  }
  let id_add_selected = -1;
  $: {
    if ($recognition == "monitoreadas") {
      filtro(0);
    }
    if ($recognition == "con alertas") {
      filtro(1);
    }
    if ($recognition == "sin monitoreo") {
      filtro(2);
    }
  }
  let eco_f = "",
    eco_f_;
  $: {
    if (eco_f != "") {
      let change_page = false;
      for (let x in travels_fh) {
        if (travels_fh[x].id == eco_f) {
          if (f_pag != travels_fh[x].page) {
            f_pag = travels_fh[x].page;
            change_page = true;
          }
          break;
        }
      }
      buscar_unidad(eco_f, change_page);
      //let unit_seg = document.getElementById("seg_"+eco_f);
      //if(unit_seg!=null){unit_seg.scrollIntoView();maping(eco_f,{});select_prog(eco_f)}
    }
  }
  async function buscar_unidad(eco, change_page) {
    if (change_page) await tick();
    let unit_seg = document.getElementById("seg_" + eco);
    if (unit_seg != null) {
      unit_seg.scrollIntoView();
      maping(eco, {});
      select_prog(eco);
    }
    eco_f = "";
    eco_f_ = "";
  }

  async function busca_future_travel(eco) {
    let change_page = false;
    for (let x in travels_fh) {
      if (travels_fh[x].id == eco) {
        if (f_pag != travels_fh[x].page) {
          f_pag = travels_fh[x].page;
          change_page = true;
        }
        break;
      }
    }
    if (change_page) await tick();
    if (document.getElementById("seg_" + eco) != null) {
      document.getElementById("seg_" + eco).scrollIntoView();
    }
  }

  let con_close_travel_modal = false;
  let con_delete_travel_modal = false;
  function save_travel_modal(id, date_ini) {
    travel_modal_id = id;
    travel_modal_date_ini = date_ini;
    con_delete_travel_modal = true;
  }
  let caravan_mode = false;
  let caravan_group = [];
  function caravan() {
    console.log(caravan_group);
    if (caravan_mode) {
      if (caravan_group.length > 0) {
        socket_query.emit("travel_caravan", caravan_group, (data) => {
          if (data == "ok") {
            saved_type = "alert-success";
            saved_text = "Caravana creada";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
            caravan_mode = false;
            caravan_group = [];
          } else {
            saved_type = "alert-danger";
            saved_text = "Error en crear Caravana";
            saved_ok = true;
            setTimeout(function () {
              saved_ok = false;
            }, 3000);
          }
        });
      }
    } else {
      caravan_group = [];
      caravan_mode = true;
    }
  }
  let actual_name = "";
  let last_geocode = "";
  let last_geocode_pos = "";
  async function geocode(lat, lon, mobid) {
    var latlng = { lat: lat, lng: lon };
    last_geocode = mobid;

    if (last_geocode_pos != JSON.stringify({ lat: lat, lon: lon })) {
      last_geocode_pos = JSON.stringify({ lat: lat, lon: lon });
      /*
            geocoder.geocode({'location': latlng}, function(results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        console.log(results[0].formatted_address);
                        actual_name= results[0].formatted_address;
                        if(travels_fz[mobid].geo_stay[0].split("-")[0]=="Geocerca_automatica"||travels_fz[mobid].geo_stay[0]=="")
                        {travels_fz[mobid].geo_stay[0] = actual_name;}
                    } 
                    else {
                        console.log("error en geocode");
                        actual_name = "";
                    }
                } 
                else {
                    console.log("error en geocode2",status);
                    actual_name = "";
                }
            });
            */
      // Modo Nominatim
      let dir = await fetch(
        EXT_OMNI_GEOC_URL + "/reverse?lat=" +
          lat +
          "&lon=" +
          lon +
          "&format=json&polygon_text=1"
      );
      let dir_ = await dir.json();
      //console.log(dir_);
      if (
        typeof dir_.display_name != "undefined" &&
        typeof travels_fz[mobid].geo_stay[0] != "undefined"
      ) {
        //console.log(dir_.display_name);
        actual_name = dir_.display_name;
        if (
          travels_fz[mobid].geo_stay[0].split("-")[0] ==
            "Geocerca_automatica" ||
          travels_fz[mobid].geo_stay[0] == ""
        ) {
          travels_fz[mobid].geo_stay[0] = actual_name;
        }
      } else {
        console.log("error en geocode");
        actual_name = "";
      }
    }
  }
  // Prototipo
  let coordenada_key = [];
  let coordenada_ruta_key = [];
  let last_estimado = "";
  async function ruta_estimada(mobid) {
    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
    }
    if (true) {
      //(last_estimado!=mobid)
      coordenada_key = [];
      let rec_p = JSON.parse(await units_travel_db.getItem(mobid));
      for (var x in rec_p) {
        if (typeof rec_p[x].pos != "undefined") {
          let lat, lng;
          for (let y in rec_p[x].pos) {
            lat = (rec_p[x]["pos_start"][0] - rec_p[x]["pos"][y][0]) / 10000;
            lng = (rec_p[x]["pos_start"][1] - rec_p[x]["pos"][y][1]) / 10000;
            coordenada_key.push([lat, lng]);
          }
          coordenada_key[coordenada_key.length - 1] = [lat, lng, 0];
        }
      }
      coordenada_ruta_key = [];
      if (typeof $travels[mobid] != "undefined") {
        for (let x in $travels[mobid].travel) {
          if (typeof $travels[mobid].travel[x].pos != "undefined") {
            for (let y in $travels[mobid].travel[x].pos) {
              let lat =
                ($travels[mobid].travel[x]["pos_start"][0] -
                  $travels[mobid].travel[x]["pos"][y][0]) /
                10000;
              let lng =
                ($travels[mobid].travel[x]["pos_start"][1] -
                  $travels[mobid].travel[x]["pos"][y][1]) /
                10000;
              coordenada_ruta_key.push([lat, lng]);
            }
          }
        }
      }
    }
    last_estimado = mobid;
    if (coordenada_ruta_key.length > 4) {
      let env = [];
      for (
        let x = coordenada_ruta_key.length - 4;
        x < coordenada_ruta_key.length;
        x++
      ) {
        env.push(coordenada_ruta_key[x]);
      }
      //console.log(env)
      ruta_comp3(env, coordenada_key, mobid);
    }
  }
  var error = 0.01; //1000 metros
  function ruta_comp3(ruta_ev, ruta_org, mobid) {
    let org_pos = 0;
    let x1, y1, x2, y2, x, y, m, b, p_rec, x_rec, y_rec, dentro_x, dentro_y;

    let change = 0;

    let z = 0; // Punto acutual
    //console.log("ruta total",ruta_ev.length);
    let ruta_rest = [];
    for (var w = org_pos; w < ruta_org.length - 1; w++) {
      // Carga de puntos
      x = ruta_ev[z][0];
      y = ruta_ev[z][1];

      // Carga de la recta de la ruta madre
      x1 = ruta_org[w][0];
      y1 = ruta_org[w][1];
      x2 = ruta_org[w + 1][0];
      y2 = ruta_org[w + 1][1];
      m = (y2 - y1) / (x2 - x1);

      if (isFinite(m)) {
        b = y1 - m * x1;
        p_rec = Math.abs(m * x - y + b) / Math.sqrt(Math.pow(m, 2) + 1);
        x_rec = (x + m * y - b * m) / (Math.pow(m, 2) + 1);
        y_rec = (Math.pow(m, 2) * y + m * x + b) / (Math.pow(m, 2) + 1);
      } else {
        p_rec = Math.abs(x1 - x);
        x_rec = x1;
        y_rec = y;
      }
      dentro_x =
        x1 > x2
          ? x_rec <= x1 + error && x_rec >= x2 - error
            ? true
            : false
          : x1 < x2
          ? x_rec >= x1 - error && x_rec <= x2 + error
            ? true
            : false
          : true;
      dentro_y =
        y1 > y2
          ? y_rec <= y1 + error && y_rec >= y2 - error
            ? true
            : false
          : y1 < y2
          ? y_rec >= y1 - error && y_rec <= y2 + error
            ? true
            : false
          : true;
      p_rec = ((p_rec * Math.PI) / 180) * 6371;

      let d1 = Math.sqrt(Math.pow(y2 - y, 2) + Math.pow(x2 - x, 2)); // Distancia a puntos.
      d1 = ((d1 * Math.PI) / 180) * 6371;

      let d2 = Math.sqrt(Math.pow(y1 - y, 2) + Math.pow(x1 - x, 2));
      d2 = ((d2 * Math.PI) / 180) * 6371;

      if ((dentro_x && dentro_y && p_rec < 1) || d1 < 1 || d2 < 1) {
        // Distancia con punto central
        //console.log("distancia central",p_rec,w,z);
        z++;
      } else if (d1 > 10 && d2 > 10) {
        // Supera distancia de apego
        //if(z>0) console.log("ruta se aleja",z,w,d1,d2,p_rec);
        z = 0;
      }

      if (z >= ruta_ev.length - 1) {
        //console.log("flujo terminado");
        ruta_rest.push([{ lat: $live[mobid].lat, lng: $live[mobid].lon }]);
        for (let f = w + 3; f < ruta_org.length - 1; f++) {
          if (typeof ruta_org[f][2] == "undefined") {
            ruta_rest[ruta_rest.length - 1].push({
              lat: ruta_org[f][0],
              lng: ruta_org[f][1],
            });
          } else {
            break;
          }
        }
        z = 0;
      }
    }
    //console.log(ruta_rest)
    if (ruta_rest.length > 0) {
      let lineSymbol = {
        path: "M 0,-1 0,1",
        strokeOpacity: 1,
        scale: 4,
      };
      if (typeof l_ruta_estimada != "undefined") {
        l_ruta_estimada.setMap(null);
      }
      if (ruta_rest.length > 0) {
        l_ruta_estimada = new google.maps.Polyline({
          path: ruta_rest[0],
          geodesic: true,
          strokeColor: "#2f21f3",
          strokeOpacity: 0,
          strokeWeight: 2.5,
          map: map,
          icons: [
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ],
        });
        if (ruta_rest[0].length > 3) osrm_future(ruta_rest[0]);
      }
    }
  }
  async function osrm_destino(lat, lon, zIndex, mobid) {
    // OSRM
    let coordenada_osrm = "";
    coordenada_osrm =
      $live[mobid].lon + "," + $live[mobid].lat + ";" + lon + "," + lat;

    let osrm_r = await fetch(
      EXT_OMNI_ROUTE_URL + "/route/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full"
    );
    osrm_r = await osrm_r.json();
    if (osrm_r.code == "Ok") {
      let coordenada = [];
      for (let t in osrm_r.routes) {
        for (let y in osrm_r.routes[t].geometry.coordinates) {
          coordenada.push({
            lat: osrm_r.routes[t].geometry.coordinates[y][1],
            lng: osrm_r.routes[t].geometry.coordinates[y][0],
          });
        }
      }
      let lineSymbol = {
        path: "M 0,-1 0,1",
        strokeOpacity: 1,
        scale: 4,
      };
      if (typeof l_ruta_estimada != "undefined") {
        l_ruta_estimada.setMap(null);
      }
      l_ruta_estimada = new google.maps.Polyline({
        path: coordenada,
        geodesic: true,
        strokeColor: "#2f21f3",
        strokeOpacity: 0,
        strokeWeight: 2.5,
        map: map,
        icons: [
          {
            icon: lineSymbol,
            offset: "0",
            repeat: "20px",
          },
        ],
      });
    }
  }
  async function osrm(coordenada, zIndex, mobid) {
    // OSRM
    let coordenada_osrm = "";
    let radius_osrm = "";
    for (let t in coordenada) {
      coordenada_osrm =
        coordenada_osrm + coordenada[t].lng + "," + coordenada[t].lat + ";";
    }
    coordenada_osrm =
      coordenada_osrm + $live[mobid].lon + "," + $live[mobid].lat + ";";
    coordenada_osrm =
      coordenada_osrm + $live[mobid].lon + "," + $live[mobid].lat + ";";
    radius_osrm = radius_osrm + "20%3B";
    radius_osrm = radius_osrm + "20%3B";
    for (let t in coordenada) {
      radius_osrm = radius_osrm + "20%3B";
    }

    coordenada_osrm = coordenada_osrm.slice(0, -1);
    radius_osrm = radius_osrm.slice(0, -3);
    let osrm_r = await fetch(
      EXT_OMNI_ROUTE_URL + "/match/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full&radiuses=" +
        radius_osrm
    );
    osrm_r = await osrm_r.json();
    if (osrm_r.code == "Ok") {
      if (osrm_r.matchings[0].confidence > 0.4) {
        coordenada = [];
        for (let t in osrm_r.matchings) {
          for (let y in osrm_r.matchings[t].geometry.coordinates) {
            coordenada.push({
              lat: osrm_r.matchings[t].geometry.coordinates[y][1],
              lng: osrm_r.matchings[t].geometry.coordinates[y][0],
            });
          }
        }
      }
      //console.log("confidence",osrm_r.matchings[0].confidence);
    }
    //---------

    zIndex++;
    coordenada.push({ lat: $live[mobid].lat, lng: $live[mobid].lon });
    if (typeof recorrido != "undefined") {
      recorrido.setMap(null);
    }
    if (coordenada.length > 0) {
      recorrido = new google.maps.Polyline({
        path: coordenada,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2.5,
        map: map,
        zIndex: zIndex,
        icons: [
          {
            icon: {
              path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              strokeColor: "#b71c1c",
            },
            offset: "100px",
            repeat: "100px",
          },
        ],
      });
      bc_coordenadas.postMessage({ recorrido: coordenada });
    }
  }
  async function osrm_future(coordenada) {
    // OSRM
    let coordenada_osrm = "";
    let radius_osrm = "";
    for (let t in coordenada) {
      coordenada_osrm =
        coordenada_osrm + coordenada[t].lng + "," + coordenada[t].lat + ";";
    }
    for (let t in coordenada) {
      radius_osrm = radius_osrm + "20%3B";
    }

    coordenada_osrm = coordenada_osrm.slice(0, -1);
    radius_osrm = radius_osrm.slice(0, -3);
    let osrm_r = await fetch(
      EXT_OMNI_ROUTE_URL + "/match/v1/driving/" +
        coordenada_osrm +
        "?geometries=geojson&generate_hints=false&skip_waypoints=true&overview=full&radiuses=" +
        radius_osrm
    );
    osrm_r = await osrm_r.json();
    if (osrm_r.code == "Ok") {
      if (osrm_r.matchings[0].confidence > 0.2) {
        coordenada = [];
        for (let t in osrm_r.matchings) {
          for (let y in osrm_r.matchings[t].geometry.coordinates) {
            coordenada.push({
              lat: osrm_r.matchings[t].geometry.coordinates[y][1],
              lng: osrm_r.matchings[t].geometry.coordinates[y][0],
            });
          }
        }
      }
      //console.log("confidence future",osrm_r.matchings[0].confidence);
    }
    //---------
    let lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 4,
    };
    if (typeof l_ruta_estimada != "undefined") {
      l_ruta_estimada.setMap(null);
    }
    l_ruta_estimada = new google.maps.Polyline({
      path: coordenada,
      geodesic: true,
      strokeColor: "#2f21f3",
      strokeOpacity: 0,
      strokeWeight: 2.5,
      map: map,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "20px",
        },
      ],
    });
  }
  function travel_link(id) {
    new Contextual({
      isSticky: false,
      items: [
        {
          label: "Copiar link de viaje",
          onClick: () => {
            req_travel_link(id);
          },
        },
      ],
    });
  }
  function req_travel_link(id) {
    socket_query.emit("travel_link", id, (data) => {
      if (data != "error") {
        var el = document.createElement("textarea");
        el.value = data;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        saved_type = "alert-success";
        saved_text = "Link de viaje copiado";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    });
  }
  function options_units(id, follow) {
    if (follow == 1) {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Generar alerta manual",
            onClick: () => {
              manual_alert(id);
            },
          },
          {
            label: "Crear Geocerca",
            onClick: () => {
              geo_new(id);
            },
          },
        ],
      });
    } else {
      new Contextual({
        isSticky: false,
        items: [
          {
            label: "Crear Geocerca",
            onClick: () => {
              geo_new(id);
            },
          },
        ],
      });
    }
  }
  function manual_alert(id) {
    socket_query.emit("alert_service", id, (data) => {
      if (data != "error") {
        saved_type = "alert-success";
        saved_text = "Alerta manual OK";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 1000);
      }
    });
  }
  let geo_modal = false;
  let map_geo = 0;
  let geo_new_pos = {};
  let circles_new = [];
  let type_geo_new = -1;
  let actual_geo = "";
  let actual_geo_name = "";
  let geo_data;
  function geo_new(id) {
    if (typeof $live[id] != "undefined") {
      geo_new_pos = { lat: $live[id].lat, lng: $live[id].lon };
      let geo_s = geo_search(geo_new_pos.lat, geo_new_pos.lng);
      console.log(geo_s);
      if (geo_s[1] == 1) {
        if (geo_s[2] == "") {
          // Geo completamente nueva
          type_geo_new = 0;

          type_geo_new = -1;
          saved_type = "alert-danger";
          saved_text = "La unidad debe estar detenida.";
          saved_ok = true;
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        } // Geo ya existente sin nombre
        else {
          actual_geo = geo_s[2];
          actual_geo_name = geo_s[0];
          geo_c_sel = 2;
          type_geo_new = 1;

          geo_modal = true;
        }
      } else {
        type_geo_new = -1;
        saved_type = "alert-success";
        saved_text = "La geocerca ya existe, se llama " + geo_s[0];
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    }
  }
  let geo_c_sel = 2;
  function show_geo_fence() {
    function initMap() {
      map_geo = new google.maps.Map(document.getElementById("map_geo"), {
        center: geo_new_pos,
        zoom: 17,
      });
    }
    initMap();
    if (type_geo_new == 0) {
      new_geo();
    } else if (type_geo_new == 1) {
      autom_geo(actual_geo);
    }
  }
  function autom_geo(geo_s) {
    let bounds = new google.maps.LatLngBounds();
    var geo = $geos_full[geo_s];
    geo_data = geo;
    for (let x in circles_new) {
      circles_new[x].setMap(null);
    }
    circles_new = [];
    if (geo != null) {
      let anti_f = 10;
      let last_join = "";
      while (typeof geo.join != "undefined" || anti_f == 0) {
        last_join = geo.join;
        geo = $geos_full[geo.join];
        anti_f--;
      }
      for (let y in geo["pos"]) {
        let lat = geo["pos"][y][0];
        let lng = geo["pos"][y][1];

        bounds.extend({ lat: lat + 0.000898, lng: lng });
        bounds.extend({ lat: lat, lng: lng + 0.000898 });
        bounds.extend({ lat: lat - 0.000898, lng: lng });
        bounds.extend({ lat: lat, lng: lng - 0.000898 });

        circles_new.push(
          new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            map: map_geo,
            center: { lat: lat, lng: lng },
            radius: 100,
            zIndex: 3,
          })
        );
      }
      map_geo.fitBounds(bounds);
    }
  }
  function new_geo() {
    for (let x in circles_new) {
      circles_new[x].setMap(null);
    }
    circles_new = [];
    circles_new.push(
      new google.maps.Circle({
        strokeColor: "#3f51b5",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#3f51b5",
        fillOpacity: 0.35,
        map: map_geo,
        center: map.getCenter(),
        radius: 100,
        draggable: true,
        zIndex: 4,
      })
    );
  }
  function save_geo() {
    socket_query.emit(
      "geo_save",
      actual_geo,
      actual_geo_name,
      geo_c_sel,
      geo_data,
      (data) => {
        if (data == "ok") {
          map_geo = 0;
          geo_modal = false;
          saved_ok = true;
          saved_text = "Geocerca guardada";
          saved_type = "alert-success";
          setTimeout(function () {
            saved_ok = false;
          }, 3000);
        }
      }
    );
  }
</script>

{#if saved_ok}
  <div class="alert-top alert {saved_type} mb-0 text-center" role="alert">
    <strong>{saved_text}</strong>
  </div>
{/if}

{#if geo_modal}
  <div
    class="modal fade {geo_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {geo_modal
      ? 'block'
      : 'none'}; z-index:1039;"
    use:show_geo_fence
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      role="document"
      style="min-width: 95%"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Nueva geocerca
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <div class="h-100" id="map_geo" />
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <label for="geo_name" class="col col-form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                id="geo_name"
                placeholder=""
                bind:value={actual_geo_name}
                size="30"
              />
            </div>
            <div class="d-flex">
              <label for="geo_class" class="col col-form-label"
                >Clasificación</label
              >
              <div class="btn-group btn-group-toggle ml-2" id="geo_class">
                <label class="btn btn-secondary" class:active={geo_c_sel == 2}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={2}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Inicio/Fin de Viaje
                </label>
                <label class="btn btn-secondary" class:active={geo_c_sel == 3}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={3}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Parada Autorizada
                </label>
                <label class="btn btn-secondary" class:active={geo_c_sel == 4}>
                  <input
                    type="radio"
                    bind:group={geo_c_sel}
                    value={4}
                    name="geo_c_sel"
                    autocomplete="off"
                  /> Parada No Autorizada
                </label>
              </div>
            </div>
            <div class="d-flex">
              <div>
                <button
                  on:click={() => {
                    save_geo();
                  }}
                  class="btn btn-success big"
                  type="button"
                >
                  <i class="material-icons md-85">save</i>
                  Guardar geocerca
                </button>
                <button
                  on:click={() => {
                    map_geo = 0;
                    geo_modal = false;
                  }}
                  class="btn btn-danger big"
                  type="button"
                >
                  <i class="material-icons md-85">clear</i>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if route_modal}
  <div
    class="modal fade {route_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {route_modal
      ? 'block'
      : 'none'}; z-index:1039;"
    use:show_route_map
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      role="document"
      style="min-width: 95%"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Ruta nueva
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <div class="h-100" id="map_routes" />
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              {#if route_modal_edit}
                <input
                  class="form-con"
                  type="text"
                  value="{route_modal_org == 0
                    ? $geos_class[org_selected][0]
                    : route_modal_org == 1
                    ? $geos_class[dest_selected][0]
                    : $geos_class[
                        travel_toe.sec_dests[route_modal_org - 2]
                      ][0]} a {route_modal_org == 0
                    ? $geos_class[dest_selected][0]
                    : $geos_class[
                        travel_toe.sec_dests[route_modal_org - 1]
                      ][0]}"
                  bind:this={route_name}
                  size="60"
                />
              {:else}
                <input
                  class="form-con"
                  type="text"
                  value="{route_modal_org == 0
                    ? $geos_class[org_selected][0]
                    : route_modal_org == 1
                    ? $geos_class[dest_selected][0]
                    : $geos_class[
                        future_travel[0].dest_m[route_modal_org - 2].name
                      ][0]} a {route_modal_org == 0
                    ? $geos_class[dest_selected][0]
                    : $geos_class[
                        future_travel[0].dest_m[route_modal_org - 1].name
                      ][0]}"
                  bind:this={route_name}
                  size="60"
                />
              {/if}

              <button
                on:click={save_new_route}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Guardar ruta
              </button>
              <button
                on:click={cancel_new_route}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_delete_travel_modal}
  <div
    class="modal fade {con_delete_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {con_delete_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2">warning</i> Confirmar borrado de
            viaje de la unidad {typeof $nicks_list[travel_modal_id] !=
            "undefined"
              ? $nicks_list[travel_modal_id]
              : travel_modal_id}<strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Esta accion borrará el viaje de la unidad.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  con_delete_travel_modal = false;
                  save_travel(travel_modal_id, travel_modal_date_ini);
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_delete_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if con_close_travel_modal}
  <div
    class="modal fade {con_close_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {con_close_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons red md-2">warning</i> Confirmar cierre de
            viaje de la unidad {typeof $nicks_list[travel_modal_id] !=
            "undefined"
              ? $nicks_list[travel_modal_id]
              : travel_modal_id}<strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            Esta accion terminara con el viaje de la unidad.
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <div>
              <button
                on:click={() => {
                  con_close_travel_modal = false;
                  end_travel(
                    travel_modal_id,
                    travel_modal_date_ini,
                    travel_modal_id_add
                  );
                }}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">done_outline</i>
                Confirmar
              </button>
            </div>
            <div>
              <button
                on:click={() => {
                  con_close_travel_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">not_interested</i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}
{#if close_travel_modal}
  <div
    class="modal fade {close_travel_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {close_travel_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      role="document"
      style="min-width: 20%"
    >
      <div class="modal-content" style="min-height: 30%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Comentario
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <div class="d-flex flex-column">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Razon</label>
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                bind:value={travel_end_reason}
              >
                <option value="0">Unidad terminó viaje</option>
                <option value="1">Unidad canceló viaje</option>
                <option value="2">Unidad no inició viaje</option>
              </select>
            </div>
            <textarea
              class="form-control"
              placeholder="Escribe un comentario..."
              style="width:100%;"
              bind:value={travel_end_comment}
            />
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              <button
                on:click={send_travel_modal}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Enviar Comentario
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

<main role="main" class="container-fluid h-100 w-100 pl-0 pr-0">
  <div
    style="position: fixed; top: 5px; right: 0; color: #95A5A6;z-index:20000;"
  >
    powered by VectorGPS®
  </div>
  <div class="row h-100 no-gutters">
    <div class="col-md-6 h-100">
      <div class="row h-100 no-gutters">
        <div class="col-12 h-100">
          <div class="card h-100 bg-light card-b">
            <div class="d-flex flex-column h-100">
              <div
                class="card-header b-0  text-white"
                style="line-height: 1.5;background-color: rgb(128, 181, 57); font-weight: bold;"
              >
                <div class="d-flex">
                  <div class="flex-grow-1 ">
                    <i class="material-icons md-85">verified_user</i> Equipment
                    <span
                      tooltip="Unidades Totales"
                      class="badge badge-pill badge-primary"
                      >{Object.keys(travels_fz).length}</span
                    >
                    <span
                      tooltip="Unidades con alertas"
                      class="badge badge-pill badge-danger">{total_alerts}</span
                    >
                    <span
                      tooltip="Unidades con monitor"
                      class="badge badge-pill badge-success"
                      >{total_follow}</span
                    >
                    <span
                      tooltip="Alertas en espera"
                      class="badge badge-pill badge-warning"
                      >{total_wating}</span
                    >
                  </div>
                  {#if f_todas == 1 && paginas_l.length > 1}
                    <div>
                      Pages
                      <div class="btn-group mx-2" role="group">
                        {#each paginas_l as pag_n}
                          <button
                            on:click|preventDefault={() => filtro(7 + pag_n)}
                            type="button"
                            class="btn {f_pag == pag_n
                              ? 'btn-info'
                              : 'btn-outline-info'}">{pag_n + 1}</button
                          >
                        {/each}
                      </div>
                    </div>
                  {/if}
                  <div class="d-flex justify-content-end">
                    <input
                      on:click={() => {
                        eco_f_ = "";
                      }}
                      bind:value={eco_f_}
                      list="lista_unidades"
                      placeholder="Search Equipment"
                      size="20"
                      on:change={(event) => {
                        eco_f = "";
                        for (let w in $nicks_list) {
                          if ($nicks_list[w] == event.target.value) {
                            eco_f = w;
                          }
                        }
                      }}
                    />
                    <datalist id="lista_unidades">
                      {#each units_list_p as item, i}
                        <option
                          value={typeof $nicks_list[item] != "undefined"
                            ? $nicks_list[item]
                            : item}
                        />{/each}
                    </datalist>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row-reverse align-items-center my-1 ">
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(0)}
                    type="button"
                    class="btn {f_monitor == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Monitored</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(1)}
                    type="button"
                    class="btn {f_alertas == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">With alerts</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(2)}
                    type="button"
                    class="btn {f_todas == 1 ? 'btn-info' : 'btn-outline-info'}"
                    >Without monitoring</button
                  >
                </div>
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(3)}
                    type="button"
                    class="btn {f_viaje == 1 ? 'btn-info' : 'btn-outline-info'}"
                    >Moving</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(4)}
                    type="button"
                    class="btn {f_sinviaje == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Parked</button
                  >
                </div>
                <div class="btn-group mx-2" role="group">
                  <button
                    on:click|preventDefault={() => filtro(5)}
                    type="button"
                    class="btn {f_dispositivos == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Equipment</button
                  >
                  <button
                    on:click|preventDefault={() => filtro(6)}
                    type="button"
                    class="btn {f_unidades == 1
                      ? 'btn-info'
                      : 'btn-outline-info'}">Trackers</button
                  >
                </div>
              </div>
              <div
                class="card-body flex-grow-1 overflow-auto "
                style="overflow-x: hidden;"
                id="followed_travel_list"
              >
                <!--
                                {#each travels_fw as item,i (item.id)}
                                    {#if ((f_monitor==1&&item.oper!="Desconocido")||(f_todas==1&&item.oper=="Desconocido")||(f_alertas==1&&((item.alerts_list.length>0&&item.monitor_crtl.follow==1)||item.alerts_now>0)))&&((f_viaje==1&&item.org.time!="")||(f_sinviaje==1&&item.org.time==""))&&((f_unidades==1&&typeof future_travel_master[item.id]!="undefined")||(f_dispositivos==1))}
                                        <div id="seg_{item.id}" class="card mb-1 mx-2 {item.state=="OK"?'':'big-border border-danger'} {selected==item.id?'med-border border-info':''}" style="font-size:0.78rem" use:obs_travel>
                                            <div on:click={(s)=>{maping(item.id,s);select_prog(item.id)}} class="card-header b-0">
                                                <div class="d-flex">
                                                    <div class="d-flex flex-column flex-grow-1  mb-0">
                                                        <div><i tooltip="{item.id}" class="material-icons" style="color:{item.monitor_crtl.follow==0?'#78909c':item.alerts_now>0?"#df1616":item.alerts_list.length>0?"#df1616":'rgb(24, 179, 45)'}">verified_user</i>
                                                        <strong>
                                                        {typeof $nicks_list[item.id]!='undefined' ? $nicks_list[item.id] :item.id }
                                                        {#if f_unidades==1&&typeof future_travel_master[item.id]!="undefined"}
                                                          {#each future_travel_master[item.id] as id_ex,i}
                                                                <span style="color:#607D8B;">,{typeof $nicks_list[id_ex]!='undefined' ? $nicks_list[id_ex] :id_ex }</span>
                                                            {/each}
                                                        {/if}
                                                        </strong> {item.geo_stay[0]} 
                                                        {#each item.alerts_list as alerts (alerts[3])}
                                                            <i tooltip="{alerts[0]} {moment(new Date(alerts[2]*1000)).format('DD/MM/YY HH:mm')}" class="material-icons md-90" style="color:#a30000">{alerts[1]}</i>
                                                        {/each}
                                                        </div>
                                                        <div>
                                                            {#if item.org.time!=""||item.oper!="Desconocido"}
                                                                <i tooltip="Origen" class="material-icons md-90" style="color:#26a69a">{item.org.time!=""?"play_circle_outline":"change_history"}</i> <strong>{item.org.time} | </strong><span style="{false?"color:#2196f3":""}"><strong>{item.org.name!="Desconocido"?item.org.name:item.geo_stay[0]}</strong></span>
                                                            {:else}
                                                                <i class="material-icons md-90" style="color:#26a69a">change_history</i> <strong> Estacionada, sin viaje asignado</strong>
                                                            {/if}
                                                        </div>
                                                        <div>
                                                            {#if item.org.time!=""||item.oper!="Desconocido"}
                                                                <i tooltip="Destino" class="material-icons md-90" style="color:#26a69a">stop</i>
                                                                {#if show_destinos!=item.id}
                                                                    <span on:click={()=>{destino_edit(item.id)}} style="{item.dest.name=="Desconocido"?"color:#2196f3":""}"><strong id="change_destino">{typeof $geos_class[item.dest.name]!='undefined'? $geos_class[item.dest.name][0]:item.dest.name}</strong></span>
                                                                {:else}
                                                                    <select id="destino_list"  bind:value={destino_selected}>
                                                                        <option value="">Desconocido</option>
                                                                        {#each $geos_class_list as item,i}
                                                                            <option value={item[0]}>{item[1]}</option>
                                                                        {/each}
                                                                    </select>
                                                                    <button id="save_destino" on:click={()=>{save_destino(item.id,destino_selected)}} type="button" class="btn btn-success">Guardar</button>
                                                                    <button id="cancel_save_destino" on:click={()=>{show_destinos=-1;}} type="button" class="btn btn-danger">Cancelar</button>
                                                                {/if}
                                                            {/if}
                                                        </div>
                                                        <div>
                                                            {#if item.org.time!=""||item.oper!="Desconocido"}
                                                                {#if show_rutas!=item.id}
                                                                    <i tooltip="Ruta" class="material-icons md-90" style="color:#26a69a">directions</i>
                                                                    <span tooltip="{typeof $route_list_d[item.ruta.name]!='undefined'? $route_list_d[item.ruta.name]:"Nombre no disponible"}" on:click={()=>{ruta_edit(item.id)}} style="{item.ruta.name=="Desconocida"?"color:#2196f3":""}"><strong id="change_ruta">{typeof $route_list_d[item.ruta.name]!='undefined'? $route_list_d[item.ruta.name].length>35?$route_list_d[item.ruta.name].slice(0,35)+"...":$route_list_d[item.ruta.name]:"Nombre no disponible"}</strong></span>
                                                                {:else}
                                                                    <select id="ruta_list"  bind:value={ruta_selected}>
                                                                    <option value="">Desconocida</option>
                                                                        {#each route_list_ as item_,i}
                                                                            {#if item.dest.name=="Desconocido"||item.dest.name==item_[3][2]||$geos_class_join[item.dest.name][2]==item_[3][2]}
                                                                                <option value={item_[0]}>{item_[1]}</option>
                                                                            {/if}
                                                                        {/each}
                                                                    </select>
                                                                    <button id="save_ruta" on:click={()=>{save_ruta(item.id,ruta_selected)}} type="button" class="btn btn-success">Guardar</button>
                                                                    <button id="cancel_save_ruta" on:click={()=>{show_rutas=-1;}} type="button" class="btn btn-danger">Cancelar</button>
                                                                {/if}
                                                            {/if}
                                                        </div>
                                                        
                                                    </div>
                                                    <div class="d-flex flex-column">
                                                        <div class="d-flex justify-content-end mb-1">
                                                            <div class="p-1"><strong>GPS</strong> <i tooltip="{item.gps.level}" class="material-icons {item.gps.level<1.5?'green':'red'}">{item.gps.level<1.5?'location_on':'location_off'}</i></div>
                                                            <div class="p-1"><strong>{typeof item.gsm.net!='undefined'?item.gsm.net:"GSM"}</strong><i tooltip="-{item.gsm.level}" class="material-icons {item.gsm.level<90?'green':'red'}">{item.gsm.level<90?'signal_cellular_alt':'signal_cellular_connected_no_internet_4_bar'}</i></div>
                                                            <div class="p-1"><i tooltip="Última comunicación" class="material-icons {item.gsm.last?'green':'red'}">{item.gsm.last?'sync':'sync_problem'}</i> <strong>{time_code_s(item.gsm.text)}<strong></div>
                                                            {#if item.alerts_now>0}
                                                                <div class="p-1"> 
                                                                    <a href="/" on:click|preventDefault><i mobid={item.id} id="alerts_box" tooltip="Alertas" class="material-icons {item.proto_status==""?"red":"yei"}">warning</i> </a>
                                                                    <strong>{item.alerts_now}</strong>
                                                                </div>
                                                            {/if}
                                                            {#if f_unidades==1&&typeof future_travel_master[item.id]!="undefined"}
                                                                {#each future_travel_master[item.id] as id_ex,i}
                                                                    {#if typeof travels_fw[travels_fw_master[id_ex]]!="undefined"}
                                                                        {#if travels_fw[travels_fw_master[id_ex]].alerts_now>0}
                                                                            <div class="p-1"> 
                                                                                <a href="/" on:click|preventDefault><i mobid={travels_fw[travels_fw_master[id_ex]].id} id="alerts_box" tooltip="Alertas" class="material-icons {travels_fw[travels_fw_master[id_ex]].proto_status==""?"red":"yei"}">warning</i> </a>
                                                                                <strong>{travels_fw[travels_fw_master[id_ex]].alerts_now}</strong>
                                                                            </div>
                                                                        {/if}
                                                                    {/if}
                                                                {/each}
                                                            {/if}
                                                        </div>
                                                        <div class="d-flex justify-content-end mb-1">
                                                            <div class="p-1">
                                                                <i tooltip="Velocidad" class="material-icons green">speed</i> <strong>{item.mov.speed} Km/hr</strong>
                                                            </div>
                                                            <div class="p-1">
                                                                <i tooltip="Tiempo detenida {item.mov.time_stop}min" class="material-icons {item.ign==0?'gray':item.mov.time_stop>3?'yei':'green'}">pause_presentation</i> <strong>{time_code(item.mov.time_stop)}</strong>
                                                            </div>
                                                            <div class="p-1">
                                                                <i tooltip="Ignición {item.ign==1?"On":"Off"}" class="material-icons {item.ign==1?'green':'gray'}" >vpn_key</i>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-end align-items-center ">
                                                            <i tooltip="Operador" class="material-icons md-90" style="color:#26a69a">person</i> 
                                                            {#if show_drivers!=item.id}
                                                                <span on:click={()=>{drivers_edit(item.id)}} style="{item.oper=="Desconocido"||item.oper==""?"color:#2196f3":""}"><strong id="change_driver">{typeof $drivers[item.oper]!='undefined'?$drivers[item.oper].name:item.oper}</strong></span>
                                                            {:else}
                                                                <select id="driver_list"  bind:value={driver_selected}>
                                                                    <option value="">Desconocido</option>
                                                                    {#each $drivers_list as item,i}
                                                                        <option value={item[0]}>{item[1]["name"]}</option>
                                                                    {/each}
                                                                </select>
                                                                <button id="save_driver" on:click={()=>{save_driver(item.id,driver_selected)}} type="button" class="btn btn-success mx-1">Guardar</button>
                                                                <button id="cancel_save_driver" on:click={()=>{show_drivers=-1;}} type="button" class="btn btn-danger mx-1">Cancelar</button>
                                                            {/if}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    {/if}
                                {/each}
                                -->
                {#each travels_fh as item, i (item.id)}
                  {#if ((f_pag == item.page && f_todas == 1) || f_todas == 0) && typeof travels_fz[item.id].ok != "undefined" && ((f_monitor == 1 && travels_fz[item.id].oper != "Desconocido") || (f_todas == 1 && travels_fz[item.id].oper == "Desconocido") || (f_alertas == 1 && ((travels_fz[item.id].alerts_list.length > 0 && travels_fz[item.id].monitor_crtl.follow == 1) || travels_fz[item.id].alerts_now > 0))) && ((f_viaje == 1 && travels_fz[item.id].org.time != "") || (f_sinviaje == 1 && travels_fz[item.id].org.time == "")) && ((f_unidades == 1 && typeof future_travel_master[item.id] != "undefined") || f_dispositivos == 1)}
                    <div
                      id="seg_{item.id}"
                      class="card mb-1 mx-2 {travels_fz[item.id].state == 'OK'
                        ? ''
                        : 'big-border border-danger'} {selected == item.id
                        ? 'med-border border-info'
                        : ''}"
                      style="font-size:0.78rem"
                      use:monitor_v
                      on:contextmenu|preventDefault={() =>
                        options_units(
                          item.id,
                          travels_fz[item.id].monitor_crtl.follow
                        )}
                    >
                      <div
                        on:click={(s) => {
                          maping(item.id, s);
                          select_prog(item.id);
                        }}
                        class="card-header b-0"
                      >
                        <div class="d-flex">
                          <div class="d-flex flex-column flex-grow-1  mb-0">
                            <div>
                              <i
                                tooltip={item.id}
                                class="material-icons"
                                style="color:{travels_fz[item.id].monitor_crtl
                                  .follow == 0
                                  ? '#78909c'
                                  : travels_fz[item.id].alerts_now > 0
                                  ? '#df1616'
                                  : travels_fz[item.id].alerts_list.length > 0
                                  ? '#df1616'
                                  : 'rgb(24, 179, 45)'}">verified_user</i
                              >
                              <strong>
                                {typeof $nicks_list[item.id] != "undefined"
                                  ? $nicks_list[item.id]
                                  : item.id}
                                {#if f_unidades == 1 && typeof future_travel_master[item.id] != "undefined"}
                                  {#each future_travel_master[item.id] as id_ex, i}
                                    <span style="color:#607D8B;"
                                      >,{typeof $nicks_list[id_ex] !=
                                      "undefined"
                                        ? $nicks_list[id_ex]
                                        : id_ex}</span
                                    >
                                  {/each}
                                {/if}
                              </strong>
                              <span tooltip={travels_fz[item.id].geo_stay[0]}
                                >{typeof travels_fz[item.id].geo_stay[0] !=
                                "undefined"
                                  ? travels_fz[item.id].geo_stay[0].substr(
                                      0,
                                      45
                                    )
                                  : ""}</span
                              >
                              {#if travels_fz[item.id].alerts_list.length > 0}
                                {#each travels_fz[item.id].alerts_list as alerts (alerts[3])}
                                  <i
                                    tooltip="{alerts[0]} {moment(
                                      new Date(alerts[2] * 1000)
                                    ).format('DD/MM/YY HH:mm')}"
                                    class="material-icons md-90"
                                    style="color:#a30000">{alerts[1]}</i
                                  >
                                {/each}
                              {/if}
                            </div>
                            <div>
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                <i
                                  tooltip="Origen"
                                  class="material-icons md-90"
                                  style="color:#26a69a"
                                  >{travels_fz[item.id].org.time != ""
                                    ? "play_circle_outline"
                                    : "change_history"}</i
                                >
                                <strong
                                  >{travels_fz[item.id].org.time} |
                                </strong><span
                                  style={false ? "color:#2196f3" : ""}
                                  ><strong
                                    >{travels_fz[item.id].org.name !=
                                    "Desconocido"
                                      ? travels_fz[item.id].org.name
                                      : travels_fz[item.id].geo_stay[0]}</strong
                                  ></span
                                >
                              {:else}
                                <i
                                  class="material-icons md-90"
                                  style="color:#26a69a">change_history</i
                                >
                                <strong>
                                  Estacionada, sin viaje asignado</strong
                                >
                              {/if}
                            </div>
                            <div>
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                <i
                                  tooltip="Destino"
                                  class="material-icons md-90"
                                  style="color:#26a69a">stop</i
                                >
                                {#if show_destinos != item.id}
                                  <span
                                    on:click={() => {
                                      destino_edit(item.id);
                                    }}
                                    style={travels_fz[item.id].dest.name ==
                                    "Desconocido"
                                      ? "color:#2196f3"
                                      : ""}
                                    ><strong id="change_destino"
                                      >{typeof $geos_class[
                                        travels_fz[item.id].dest.name
                                      ] != "undefined"
                                        ? $geos_class[
                                            travels_fz[item.id].dest.name
                                          ][0]
                                        : travels_fz[item.id].dest.name}</strong
                                    ></span
                                  >
                                {:else}
                                  <select
                                    id="destino_list"
                                    bind:value={destino_selected}
                                  >
                                    <option value="">Desconocido</option>
                                    {#each $geos_class_list as item, i}
                                      <option value={item[0]}>{item[1]}</option>
                                    {/each}
                                  </select>
                                  <button
                                    id="save_destino"
                                    on:click={() => {
                                      save_destino(item.id, destino_selected);
                                    }}
                                    type="button"
                                    class="btn btn-success">Guardar</button
                                  >
                                  <button
                                    id="cancel_save_destino"
                                    on:click={() => {
                                      show_destinos = -1;
                                    }}
                                    type="button"
                                    class="btn btn-danger">Cancelar</button
                                  >
                                {/if}
                              {/if}
                            </div>
                            <div>
                              {#if travels_fz[item.id].org.time != "" || travels_fz[item.id].oper != "Desconocido"}
                                {#if show_rutas != item.id}
                                  <i
                                    tooltip="Ruta"
                                    class="material-icons md-90"
                                    style="color:#26a69a">directions</i
                                  >
                                  <span
                                    tooltip={typeof $route_list_d[
                                      travels_fz[item.id].ruta.name
                                    ] != "undefined"
                                      ? $route_list_d[
                                          travels_fz[item.id].ruta.name
                                        ]
                                      : "Nombre no disponible"}
                                    on:click={() => {
                                      ruta_edit(item.id);
                                    }}
                                    style={travels_fz[item.id].ruta.name ==
                                    "Desconocida"
                                      ? "color:#2196f3"
                                      : ""}
                                    ><strong id="change_ruta"
                                      >{typeof $route_list_d[
                                        travels_fz[item.id].ruta.name
                                      ] != "undefined"
                                        ? $route_list_d[
                                            travels_fz[item.id].ruta.name
                                          ].length > 35
                                          ? $route_list_d[
                                              travels_fz[item.id].ruta.name
                                            ].slice(0, 35) + "..."
                                          : $route_list_d[
                                              travels_fz[item.id].ruta.name
                                            ]
                                        : "Nombre no disponible"}</strong
                                    ></span
                                  >
                                {:else}
                                  <select
                                    id="ruta_list"
                                    bind:value={ruta_selected}
                                  >
                                    <option value="">Desconocida</option>
                                    {#each route_list_ as item_, i}
                                      {#if travels_fz[item.id].dest.name == "Desconocido" || travels_fz[item.id].dest.name == item_[3][2] || $geos_class_join[travels_fz[item.id].dest.name][2] == item_[3][2]}
                                        <option value={item_[0]}
                                          >{item_[1]}</option
                                        >
                                      {/if}
                                    {/each}
                                  </select>
                                  <button
                                    id="save_ruta"
                                    on:click={() => {
                                      save_ruta(item.id, ruta_selected);
                                    }}
                                    type="button"
                                    class="btn btn-success">Guardar</button
                                  >
                                  <button
                                    id="cancel_save_ruta"
                                    on:click={() => {
                                      show_rutas = -1;
                                    }}
                                    type="button"
                                    class="btn btn-danger">Cancelar</button
                                  >
                                {/if}
                              {/if}
                            </div>
                          </div>
                          <div class="d-flex flex-column">
                            <div class="d-flex justify-content-end mb-1">
                              <div class="p-1">
                                <strong>GPS</strong>
                                <i
                                  tooltip={travels_fz[item.id].gps.level}
                                  class="material-icons {travels_fz[item.id].gps
                                    .level < 1.5
                                    ? 'green'
                                    : 'red'}"
                                  >{travels_fz[item.id].gps.level < 1.5
                                    ? "location_on"
                                    : "location_off"}</i
                                >
                              </div>

                              <div class="p-1">
                                <strong
                                  >{typeof travels_fz[item.id].gsm.net !=
                                  "undefined"
                                    ? travels_fz[item.id].gsm.net
                                    : "GSM"}</strong
                                ><i
                                  tooltip="-{travels_fz[item.id].gsm.level}"
                                  class="material-icons {travels_fz[item.id].gsm
                                    .level < 90
                                    ? 'green'
                                    : 'red'}"
                                  >{travels_fz[item.id].gsm.level < 90
                                    ? "signal_cellular_alt"
                                    : "signal_cellular_connected_no_internet_4_bar"}</i
                                >
                              </div>

                              <div class="p-1">
                                <i
                                  tooltip="Última comunicación"
                                  class="material-icons {travels_fz[item.id].gsm
                                    .last
                                    ? 'green'
                                    : 'red'}"
                                  >{travels_fz[item.id].gsm.last
                                    ? "sync"
                                    : "sync_problem"}</i
                                >
                                <strong
                                  >{travels_fz[item.id].gsm.text}<strong
                                  /></strong
                                >
                              </div>

                              {#if travels_fz[item.id].alerts_now > 0}
                                <div class="p-1">
                                  <a href="/" on:click|preventDefault
                                    ><i
                                      mobid={item.id}
                                      id="alerts_box"
                                      tooltip="Alertas"
                                      class="material-icons {travels_fz[item.id]
                                        .proto_status == ''
                                        ? 'red'
                                        : 'yei'}">warning</i
                                    >
                                  </a>
                                  <strong
                                    >{travels_fz[item.id].alerts_now}</strong
                                  >
                                </div>
                              {/if}
                              {#if f_unidades == 1 && typeof future_travel_master[item.id] != "undefined"}
                                {#each future_travel_master[item.id] as id_ex, i}
                                  {#if typeof travels_fz[id_ex] != "undefined"}
                                    {#if travels_fz[id_ex].alerts_now > 0}
                                      <div class="p-1">
                                        <a href="/" on:click|preventDefault
                                          ><i
                                            mobid={id_ex}
                                            id="alerts_box"
                                            tooltip="Alertas"
                                            class="material-icons {travels_fz[
                                              id_ex
                                            ].proto_status == ''
                                              ? 'red'
                                              : 'yei'}">warning</i
                                          >
                                        </a>
                                        <strong
                                          >{travels_fz[id_ex]
                                            .alerts_now}</strong
                                        >
                                      </div>
                                    {/if}
                                  {/if}
                                {/each}
                              {/if}
                            </div>
                            <div class="d-flex justify-content-end mb-1">
                              <div class="p-1">
                                <i
                                  tooltip="Velocidad"
                                  class="material-icons green">speed</i
                                >
                                <strong
                                  >{travels_fz[item.id].mov.speed} Km/hr</strong
                                >
                              </div>
                              <div class="p-1">
                                <i
                                  tooltip="Tiempo detenida {travels_fz[item.id]
                                    .mov.time_stop}min"
                                  class="material-icons {travels_fz[item.id]
                                    .ign == 0
                                    ? 'gray'
                                    : travels_fz[item.id].mov.time_stop > 3
                                    ? 'yei'
                                    : 'green'}">pause_presentation</i
                                >
                                <strong
                                  >{time_code(
                                    travels_fz[item.id].mov.time_stop
                                  )}</strong
                                >
                              </div>
                              <div class="p-1">
                                <i
                                  tooltip="Ignición {travels_fz[item.id].ign ==
                                  1
                                    ? 'On'
                                    : 'Off'}"
                                  class="material-icons {travels_fz[item.id]
                                    .ign == 1
                                    ? 'green'
                                    : 'gray'}">vpn_key</i
                                >
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-end align-items-center "
                            >
                              <i
                                tooltip="Operador"
                                class="material-icons md-90"
                                style="color:#26a69a">person</i
                              >
                              {#if show_drivers != item.id}
                                <span
                                  on:click={() => {
                                    drivers_edit(item.id);
                                  }}
                                  style={travels_fz[item.id].oper ==
                                    "Desconocido" ||
                                  travels_fz[item.id].oper == ""
                                    ? "color:#2196f3"
                                    : ""}
                                  ><strong id="change_driver"
                                    >{typeof $drivers[
                                      travels_fz[item.id].oper
                                    ] != "undefined"
                                      ? $drivers[travels_fz[item.id].oper].name
                                      : travels_fz[item.id].oper}</strong
                                  ></span
                                >
                              {:else}
                                <select
                                  id="driver_list"
                                  bind:value={driver_selected}
                                >
                                  <option value="">Desconocido</option>
                                  {#each $drivers_list as item, i}
                                    <option value={item[0]}
                                      >{item[1]["name"]}</option
                                    >
                                  {/each}
                                </select>
                                <button
                                  id="save_driver"
                                  on:click={() => {
                                    save_driver(item.id, driver_selected);
                                  }}
                                  type="button"
                                  class="btn btn-success mx-1">Guardar</button
                                >
                                <button
                                  id="cancel_save_driver"
                                  on:click={() => {
                                    show_drivers = -1;
                                  }}
                                  type="button"
                                  class="btn btn-danger mx-1">Cancelar</button
                                >
                              {/if}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  {/if}
                {/each}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 h-100">
      <div
        class="row  no-gutters"
        style="height:{mapa_ex_mode ? '0%' : '100%'}"
      >
        <div class="col-12 h-100">
          <div class="h-100" id="map" />
        </div>
      </div>
    </div>
  </div>
</main>

<style>
  .btn {
    vertical-align: initial;
    padding: 1px 6px;
    font-size: 0.78rem;
  }
  .btn.big {
    vertical-align: initial;
    padding: 5px 6px;
    font-size: 0.9rem;
  }

  .card.big-border {
    border: 3px solid;
  }
  .card.med-border {
    border: 3px solid;
  }
  .card-b {
    border: 0px;
  }
  .card-header.b-0 {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    padding-left: 0.75rem;
  }
  .card-body {
    padding-top: 0rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
    padding-left: 0rem;
  }
  .h-15 {
    height: 15%;
  }
  .h-85 {
    height: 85%;
  }

  [tooltip] {
    position: relative;
  }
  [tooltip]:before {
    content: attr(tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    padding: 8px;
    transform: translateX(-50%) scale(0);
    transform-origin: top;
    background: #757575;
    color: white;
    border-radius: 2px;
    font-size: 0.6rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    z-index: 1001;
  }
  [tooltip]:hover:before {
    transform: translateX(-50%) scale(1);
  }

  .card-header:first-child {
    border-radius: 0;
  }

  .alert-top {
    position: fixed;
    top: 3rem;
    left: 35%;
    width: 30%;
    z-index: 1050;
  }

  .form-con {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .btn-outline-info {
    color: #17a2b8;
    border-color: #17a2b8;
    background-color: white;
  }

  @font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url(../css/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");
  }
  .material-icons {
    font-family: "Material Icons";
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  .material-icons.md-1 {
    font-size: 1rem;
  }
  .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }
  .material-icons.md-85 {
    font-size: 1.3rem;
  }
  .material-icons.md-90 {
    font-size: 1.5rem;
  }
  .material-icons.md-95 {
    font-size: 1.8rem;
  }
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }
  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
  .material-icons.orange {
    color: #ff7043;
  }
  .material-icons.bblue {
    color: #26a69a;
  }
  .material-icons.green {
    color: rgb(24, 179, 45);
  }
  .material-icons.yei {
    color: #ff9800;
  }
  .material-icons.golden {
    color: #856404;
  }
  .material-icons.gray {
    color: #525a63;
  }
  .material-icons.red {
    color: #df1616;
  }
  i {
    vertical-align: middle;
    padding-bottom: 3px;
  }
  span.blue {
    color: rgb(17, 33, 255);
  }

  .btn-info {
    color: #fff;
    background-color: #729ea5;
    border-color: #729ea5;
  }
</style>
